import React, { useEffect, useRef, useMemo,useState } from "react";
import axios from "axios";
import Sidebar from "../../GlobalManagement/Pages/Sidebar";
import BackButton from "../../GlobalManagement/Pages/BackButton";
import MobileHeaderToggle from "../../GlobalManagement/Pages/MobileHeaderToggle";
import { useNavigate } from "react-router-dom";
import SearchBar from '../../GlobalManagement/Pages/SearchBar';
import toast from "react-hot-toast";
import { useLocation } from "react-router-dom";
import { 
  masterBodyArea, 
  masterContentArea, 
  masterPageShell, 
  masterHeader, 
  masterHeaderCard, 
  masterHeaderInfo, 
  masterHeaderIcon, 
  masterTitle, 
  masterAccentButton, 
  masterPrimaryButton, 
  masterTableBody, 
  masterPanel, 
  masterTable, 
  masterStickyHeadRow, 
  masterTableData, 
  masterTbody, 
  masterTableRow, 
  masterTableCell, 
  masterEditButton, 
  masterDeleteButton, 
  masterFormContainer, 
  masterFormSectionHeader, 
  masterFormGrid2, 
  masterFormGridRow, 
  masterInputLabel, 
  masterInput, 
  masterSelect, 
  masterFormActionBlock, 
  masterActiveColor, 
  masterInactiveColor, 
  masterActionButtonsContainer, 
  masterTableCellstatus,
  masterTableDatastatus,
  masterFormGrid4,
  masterFormGrid5
} from '../../GlobalManagement/Pages/masterPageStyles';
import { Users, Edit,Trash2, Plus,Save, ArrowLeft } from 'lucide-react';

const formatDateForInput = (dateString) => {
  if (!dateString) return "";
  if (typeof dateString === "string" && dateString.includes("-")) {
    const parts = dateString.split("-");
    if (parts[0].length === 2 && parts[2].length === 4) {
      return `${parts[2]}-${parts[1]}-${parts[0]}`; // Flips to YYYY-MM-DD
    }
  }
  return dateString;
};

const formatDateForStorage = (dateString) => {
  if (!dateString) return "";
  if (typeof dateString === "string" && dateString.includes("-")) {
    const parts = dateString.split("-");
    if (parts[0].length === 4) {
      return `${parts[2]}-${parts[1]}-${parts[0]}`; // Flips to DD-MM-YYYY
    }
  }
  return dateString;
};

const formatDateToDisplay = (dateString) => {
  if (!dateString || typeof dateString !== "string") return "";

  const isoMatch = dateString.match(/^(\d{4})-(\d{2})-(\d{2})$/);
  if (isoMatch) {
    return `${isoMatch[3]}/${isoMatch[2]}/${isoMatch[1]}`;
  }

  const storedMatch = dateString.match(/^(\d{2})-(\d{2})-(\d{4})$/);
  if (storedMatch) {
    return `${storedMatch[1]}/${storedMatch[2]}/${storedMatch[3]}`;
  }

  return dateString;
};

const parseDisplayDateToInput = (dateString) => {
  if (!dateString || typeof dateString !== "string") return "";

  const trimmedValue = dateString.trim();
  const displayMatch = trimmedValue.match(/^(\d{2})[/-](\d{2})[/-](\d{4})$/);
  if (displayMatch) {
    return `${displayMatch[3]}-${displayMatch[2]}-${displayMatch[1]}`;
  }

  const isoMatch = trimmedValue.match(/^(\d{4})-(\d{2})-(\d{2})$/);
  if (isoMatch) {
    return trimmedValue;
  }

  return null;
};

const formatDateTypingValue = (dateString) => {
  if (!dateString || typeof dateString !== "string") return "";

  const digitsOnly = dateString.replace(/\D/g, "").slice(0, 8);
  const day = digitsOnly.slice(0, 2);
  const month = digitsOnly.slice(2, 4);
  const year = digitsOnly.slice(4, 8);

  if (digitsOnly.length <= 2) return day;
  if (digitsOnly.length <= 4) return `${day}/${month}`;
  return `${day}/${month}/${year}`;
};

const BANK_OPTIONS = [
  "STATE BANK OF INDIA",
  "PUNJAB NATIONAL BANK",
  "BANK OF BARODA",
  "CANARA BANK",
  "UNION BANK OF INDIA",
  "BANK OF INDIA",
  "INDIAN BANK",
  "CENTRAL BANK OF INDIA",
  "UCO BANK",
  "BANK OF MAHARASHTRA",
  "INDIAN OVERSEAS BANK",
  "PUNJAB & SIND BANK",
  "FINO PAYMENTS BANK",
  "HDFC BANK",
  "ICICI BANK",
  "AXIS BANK",
  "KOTAK MAHINDRA BANK",
  "INDUSIND BANK",
  "YES BANK",
  "IDFC FIRST BANK",
  "RBL BANK",
  "FEDERAL BANK",
  "CSB BANK",
  "KARUR VYSYA BANK",
  "SOUTH INDIAN BANK",
  "CITY UNION BANK",
  "DCB BANK",
  "TAMILNAD MERCANTILE BANK",
  "BANDHAN BANK",
  "AU SMALL FINANCE BANK",
  "EQUITAS SMALL FINANCE BANK",
  "UTKARSH SMALL FINANCE BANK",
  "UJJIVAN SMALL FINANCE BANK",
  "SURYODAY SMALL FINANCE BANK",
  "ESAF SMALL FINANCE BANK",
  "NORTH EAST SMALL FINANCE BANK",
  "JANASEVA SMALL FINANCE BANK",
];

const BANK_SELECT_OPTIONS = [
  ...BANK_OPTIONS.map((bank) => ({
    label: bank,
    value: bank,
    searchText: bank,
  })),
  { label: "OTHERS", value: "OTHERS", searchText: "OTHERS OTHER" },
];

const EmployeeMaster = () => {
  const location = useLocation();
  
  const { employee, id } = location.state || {};
  const editEmployeeId = employee?._id || id || "";
  const [selectedEmployeeId, setSelectedEmployeeId] = useState(editEmployeeId);
  const [editLoadKey, setEditLoadKey] = useState(0);
  const [isLoadingFullEmployee, setIsLoadingFullEmployee] = useState(Boolean(editEmployeeId));
  const fromReminder = location.state?.fromReminder === true;
  const [loadedEmployee, setLoadedEmployee] = useState(employee || null);
  const [employeeUserId, setEmployeeUserId] = useState("");
  const activeEmployeeId = selectedEmployeeId;
  const isEditMode = Boolean(activeEmployeeId);
  const [initialEmploymentStatus, setInitialEmploymentStatus] = useState("");
  const [filteredDesignations, setFilteredDesignations] = useState([]);
  const [selectedDepartmentName, setSelectedDepartmentName] = useState("");
  const [reportingManagerEmpID, setReportingManagerEmpID] = useState("");
  const [departmentHeadEmpID, setDepartmentHeadEmpID] = useState("");
  const [reportingManagerEmployeeUserId, setReportingManagerEmployeeUserId] = useState("");
  const [departmentHeadEmployeeUserId, setDepartmentHeadEmployeeUserId] = useState("");
  const [selectedStatusFilter, setSelectedStatusFilter] = useState('');
const [departmentID, setDepartmentID] = useState("");
const [departmentName, setDepartmentName] = useState("");
const [designationID, setDesignationID] = useState("");
const [payType, setPayType] = useState('SALARY'); 
const [selectedStatus, setSelectedStatus] = useState("ALL");


  //const [employeeData, setEmployeeData] = useState(location.state?.employee || {});
  const [employeeData, setEmployeeData] = useState({
  hardCopyDocuments: {
    aadhaar: false,
    pan: false,
    bank: false,
    photograph: false,
    addressProof: false,        // Voter ID / Utility bill
    educationCertificates: false,
    experienceLetters: false,
    relievingLetter: false,
    salarySlips: false,         // last 3 months
    medicalFitness: false,
    policeVerification: false,
    vaccinationCertificate: false,
    bloodGroupProof: false,
    nominationForm: false,      // PF / Gratuity
    esiForm: false,
    pfForm: false,
    nda: false,
  },
  ...(location.state?.employee || {}),
  _id: location.state?.employee?._id || location.state?.id || "",
});

const [showTableList, setShowTableList] = useState(!location.state?.employee && !location.state?.id); // Toggle between list and form views
  const [employeeList, setEmployeeList] = useState([]);     // Stores all fetched employees for the table
  const [searchTerm, setSearchTerm] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(18);
  const [selectedDeptFilter, setSelectedDeptFilter] = useState(''); // Department filter
 const fetchEmployeeList = async () => {
    try {
      const token = localStorage.getItem("token");
      const res = await axios.get("/api/employees", {
        headers: { Authorization: `Bearer ${token}` }
      });
      
      const rawData = res.data || [];
      // Sort so newest items appear at the top
      const sortedData = rawData.sort((a, b) => {
        return String(b._id || '').localeCompare(String(a._id || ''));
      });

      setEmployeeList(sortedData);
    } catch (err) {
      toast.error("Failed to load employee list");
    }
  };

  useEffect(() => {
    if (showTableList) {
      fetchEmployeeList();
    }
  }, [showTableList]);
const filteredEmployees = useMemo(() => {
    // FIX: Use employeeList instead of employees for the table view
    return employeeList.filter((e) => {
      const fullName = `${e.firstName || ""} ${e.middleName || ""} ${e.lastName || ""}`.toUpperCase();
      const empId = (e.employeeID || "").toUpperCase();
      const employeeStatus = (e?.employmentStatus || "").toString().trim().toUpperCase();

      const q = String(searchTerm || "").toUpperCase().trim();
      const qDigits = q.replace(/\D/g, "");
      const qHasLetters = /[A-Z]/.test(q);
      const empDigits = empId.replace(/\D/g, "");

      const matchesSearch =
        !q ||
        fullName.startsWith(q) ||
        empId.startsWith(q) ||
        (!qHasLetters && qDigits && empDigits.includes(qDigits));

      const matchesStatus = !selectedStatus || selectedStatus === "ALL" || employeeStatus === selectedStatus;

      return matchesSearch && matchesStatus;
    });
  }, [employeeList, searchTerm, selectedStatus]); // FIX: dependency array includes employeeList

  const paginatedEmployees = useMemo(() => {
    if (pageSize === -1) return filteredEmployees;
    const start = (currentPage - 1) * pageSize;
    return filteredEmployees.slice(start, start + pageSize);
  }, [filteredEmployees, currentPage, pageSize]);
  
useEffect(() => {
  const fetchFullEmployeeForEdit = async () => {
    if (!activeEmployeeId) {
      setLoadedEmployee(employee || null);
      setIsLoadingFullEmployee(false);
      return;
    }

    try {
      setIsLoadingFullEmployee(true);
      const token = localStorage.getItem("token");
      // FIXED: Added "employees" back to the route so it hits `/api/employees/:id`
      const res = await axios.get(`/api/employees/${activeEmployeeId}`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      
      const fullEmployee = res?.data?.data || res?.data?.employee || res?.data || null;
      
      if (fullEmployee) {
        setLoadedEmployee(fullEmployee);
        setEmployeeData((prev) => ({
          ...prev,
          ...fullEmployee,
          hardCopyDocuments: fullEmployee.hardCopyDocuments || prev.hardCopyDocuments
        }));
      } else {
        setLoadedEmployee(employee || null);
      }
    } catch (err) {
      console.error("Failed to load full employee record:", err);
      setLoadedEmployee(employee || null);
      toast.error("Failed to load full employee details");
    } finally {
      setIsLoadingFullEmployee(false);
    }
  };

  fetchFullEmployeeForEdit();
}, [activeEmployeeId, employee, editLoadKey]);

  const [step, setStep] = useState(1);
  const [employeeID, setEmployeeID] = useState("");
  const [employmentStatus, setEmploymentStatus] = useState("");
  const [exEmployeeReason, setExEmployeeReason] = useState("");
  const [governmentRegistrationNumber, setGovernmentRegistrationNumber] = useState("");
  const [registrationState, setregistrationState] = useState("");
  const [salutation, setSalutation] = useState("");
  const [firstName, setFirstName] = useState("");
  const [middleName, setMiddleName] = useState("");
  const [lastName, setLastName] = useState("");
  const [fatherName, setFatherName] = useState("");
  const [spouseName, setSpouseName] = useState("");
  const [caste, setCaste] = useState("");
  const [subCaste, setSubCaste] = useState("");
  const [religion, setReligion] = useState("");
  const [gender, setGender] = useState("");
  const [maritalStatus, setMaritalStatus] = useState("");
  const [skillCategory, setSkillCategory] = useState("");
  const [designationName, setDesignationName] = useState(null);
  const [personalEmail, setPersonalEmail] = useState("");
  const [personalMobile, setPersonalMobile] = useState("");

  const [dob, setDob] = useState("");
  const [dor, setDor] = useState("");
  const [doj, setDoj] = useState("");
 const [statusChangeDate, setStatusChangeDate] = useState(new Date().toISOString().split("T")[0]);
  const [confirmationDate, setConfirmationDate] = useState("");
  const [nextIncrementDate, setNextIncrementDate] = useState("");
  const [eligiblePromotion, setEligiblePromotion] = useState("");
  const [employmentType, setEmploymentType] = useState("");
  const [profileImage, setProfileImage] = useState(null);
  const [reportingManager, setReportingManager] = useState("");
  const [departmentHead, setdepartmentHead] = useState("");

  const [departments, setDepartments] = useState([]);
  const [designations, setDesignations] = useState([]);
  const [employees, setEmployees] = useState([]);
  const [qualificationsMaster, setQualificationsMaster] = useState([]);
  const createEducationRow = () => ({
    qualification: "",
    discipline: "",
    institute: "",
    board: "",
    year: "",
    percentage: "",
    grade: "",
  });
  const createExperienceRow = () => ({
    id: `${Date.now()}-${Math.random().toString(16).slice(2)}`,
    organizationName: "",
    organizationType: "",
    designation: "",
    employmentType: "",
    location: "",
    startMonth: "",
    endMonth: "",
    totalDuration: "",
  });
  const createNomineeRow = () => ({
    name: "",
    relation: "",
    share: "",
    age: "",
    address: "",
    dob: "",
  });

  const [educationDetails, setEducationDetails] = useState([createEducationRow()]);
  const [experienceDetails, setExperienceDetails] = useState([createExperienceRow()]);
    // Step 3 States
const [nomineeDetails, setNomineeDetails] = useState([createNomineeRow()]);
const createEmergencyContactRow = () => ({
  name: "",
  relation: "",
  mobile: "",
  address: "",
});
const [emergencyContact, setEmergencyContact] = useState([createEmergencyContactRow()]);
const [bloodGroup, setBloodGroup] = useState("");
const [eyeSightLeft, setEyeSightLeft] = useState("");
const [eyeSightRight, setEyeSightRight] = useState("");
const [familyPlanStatus, setFamilyPlanStatus] = useState("");
const [familyPlanDate, setFamilyPlanDate] = useState("");
const [height, setHeight] = useState("");
const [weight, setWeight] = useState("");
const [identificationMark1, setIdentificationMark1] = useState("");
const [identificationMark2, setIdentificationMark2] = useState("");
const [physicallyChallenged, setPhysicallyChallenged] = useState("");

const [permanentAddress, setPermanentAddress] = useState({
  street: "",
  village: "",
  city: "",
  postOffice: "",
  policeStation: "",
  pinCode: "",
  district: "",
  state: "",
  country: "INDIA",
  mobile: "",
  email: "",
});

const [presentAddress, setPresentAddress] = useState({
  street: "",
  village: "",
  city: "",
  postOffice: "",
  policeStation: "",
  pinCode: "",
  district: "",
  state: "",
  country: "INDIA",
  mobile: "",
  email: "",
});

const [sameAsPermanent, setSameAsPermanent] = useState(false);
const [basicPay, setBasicPay] = useState("");
const [pfType, setPfType] = useState("");
const [passportNo, setPassportNo] = useState("");
const [pfNo, setPfNo] = useState("");
const [uanNo, setUanNo] = useState("");
const [esiNo, setEsiNo] = useState("");
const [panNo, setPanNo] = useState("");
// Primary Bank States
const [primaryBankName, setPrimaryBankName] = useState("");
const [primaryCustomBankName, setPrimaryCustomBankName] = useState("");
const [primaryBranch, setPrimaryBranch] = useState("");
const [primaryIfscCode, setPrimaryIfscCode] = useState("");
const [primaryAccountNo, setPrimaryAccountNo] = useState("");

// Secondary Bank States
const [secondaryBankName, setSecondaryBankName] = useState("");
const [secondaryCustomBankName, setSecondaryCustomBankName] = useState("");
const [secondaryBranch, setSecondaryBranch] = useState("");
const [secondaryIfscCode, setSecondaryIfscCode] = useState("");
const [secondaryAccountNo, setSecondaryAccountNo] = useState("");
const [payLevel, setPayLevel] = useState("");
const [aadhaarNo, setAadhaarNo] = useState("");
const [grossSalary, setGrossSalary] = useState("");
const [earningDetails, setEarningDetails] = useState([
  { headName: "", headType: "", value: "" }
]);

const [deductionDetails, setDeductionDetails] = useState([
  { headName: "", headType: "", value: "" }
]);

const [allHeads, setAllHeads] = useState([]);

const navigate = useNavigate();
  // Fetch salary heads
  useEffect(() => {
    const fetchHeads = async () => {
      try {
        const token = localStorage.getItem("token");
        const res = await axios.get("/api/salary-heads/salary-list", {
          headers: { Authorization: `Bearer ${token}` }
        });
        if (Array.isArray(res.data)) {
          setAllHeads(res.data);
        } else if (Array.isArray(res.data.data)) {
          setAllHeads(res.data.data);
        } else {
          toast.error("Invalid salary heads format", res.data);
          toast.error("Invalid salary heads data");
        }
      } catch (err) {
        toast.error(err);
        toast.error("Failed to fetch salary heads");
      }
    };
    fetchHeads();
  }, []);

//   useEffect(() => {
//   const storedID = localStorage.getItem("employeeID");
//   if (storedID) {
//     setEmployeeID(storedID);
//   }
// }, []);


  const earningHeads = Array.isArray(allHeads) ? allHeads.filter(h => h.headId.startsWith("EARN")) : [];
  const deductionHeads = Array.isArray(allHeads) ? allHeads.filter(h => h.headId.startsWith("DEDUCT")) : [];

useEffect(() => {

  if (!employmentStatus) return;
  if (!isEditMode && !employeeID) {
    const token = localStorage.getItem("token");
    axios
      .get("/api/employees/next-id", {
        params: { employmentStatus },
        headers: { Authorization: `Bearer ${token}` }
      })
      .then((res) => {
        // Only set if the user hasn't started typing while the request was loading
        setEmployeeID(res.data.employeeID || "");
        setEmployeeUserId(res.data.employeeUserId || "");
      })
      .catch((err) => {
        toast.error("Error fetching next ID:", err);
      });
    return;
  }

  if (employmentStatus !== initialEmploymentStatus && employeeID) {
   
    const parts = employeeID.split("-");
    const numberPart = parts.length > 1 ? parts[1] : employeeID.slice(2);
    setEmployeeID(`${employmentStatus}-${numberPart}`);
  }
}, [employmentStatus, isEditMode, initialEmploymentStatus]); 

const handleDelete = async (id) => {
    if (!window.confirm("Are you sure you want to delete this employee?")) return;
    try {
      const token = localStorage.getItem("token");
      await axios.delete(`/api/employees/${id}`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      toast.success("Employee deleted successfully");
      fetchEmployeeList(); // Refresh table
    } catch (err) {
      toast.error("Delete failed");
    }
  };

useEffect(() => {
  if (!selectedDepartmentName) {
    setFilteredDesignations([]);
    return;
  }

  const filtered = designations
    .filter(d => d.departmentName === selectedDepartmentName)
    .map(d => ({
      label: d.designationName,
      value: d._id
    }));

  setFilteredDesignations(filtered);
}, [selectedDepartmentName, designations]);


useEffect(() => {
  if (loadedEmployee && departments.length && designations.length) {
    const dept = departments.find(d => d.value === loadedEmployee.departmentID);
    setDepartmentID(dept?._id || "");
    setSelectedDepartmentName(dept?.deptName || "");

    const desig = designations.find(d => d.value === loadedEmployee.designationID);
    setDesignationID(desig?._id || "");
  }
}, [loadedEmployee, departments, designations]);



useEffect(() => {
  // Only proceed if employee data is available
  if (loadedEmployee) {
    // 1. Basic Info
    setEmployeeID(loadedEmployee.employeeID || "");
    setEmployeeUserId(loadedEmployee.employeeUserId || "");
    setInitialEmploymentStatus(loadedEmployee.employmentStatus || "");
    setEmploymentStatus(loadedEmployee.employmentStatus || "");
    setExEmployeeReason(loadedEmployee.exEmployeeReason || "");
    setGovernmentRegistrationNumber(loadedEmployee.governmentRegistrationNumber || "");
    setregistrationState(loadedEmployee.registrationState || "");
    setSalutation(loadedEmployee.salutation || "");
    setFirstName(loadedEmployee.firstName || "");
    setMiddleName(loadedEmployee.middleName || "");
    setLastName(loadedEmployee.lastName || "");
    setFatherName(loadedEmployee.fatherName || "");
    setSpouseName(loadedEmployee.spouseName || "");
    setCaste(loadedEmployee.caste || "");
    setSubCaste(loadedEmployee.subCaste || "");
    setReligion(loadedEmployee.religion || "");
    setMaritalStatus(loadedEmployee.maritalStatus || "");
    setSkillCategory(loadedEmployee.skillCategory || "");
    setGender(loadedEmployee.gender || "");
    
    setPersonalEmail(
      loadedEmployee.personalEmail ||
      loadedEmployee.presentAddress?.email ||
      loadedEmployee.permanentAddress?.email ||
      ""
    );
    setPersonalMobile(
      loadedEmployee.personalMobile ||
      loadedEmployee.presentAddress?.mobile ||
      loadedEmployee.permanentAddress?.mobile ||
      ""
    );

    // 2. Department & Designation Prefill
    if (departments.length > 0) {
      const foundDept = departments.find(d => d.label === loadedEmployee.departmentName);
      if (foundDept) {
        setDepartmentID(foundDept.value);
        setSelectedDepartmentName(foundDept.label);
      }
    }

    if (designations.length > 0) {
      const foundDesig = designations.find(d => d.label === loadedEmployee.designationName);
      if (foundDesig) {
        setDesignationID(foundDesig.value);
      }
    }

    setDob(formatDateForInput(loadedEmployee.dob));
    setDor(formatDateForInput(loadedEmployee.dor));
    setDoj(formatDateForInput(loadedEmployee.doj));
    const todayDate = new Date().toISOString().split("T")[0];
    const existingStatusDate = formatDateForInput(loadedEmployee.statusChangeDate);
    setStatusChangeDate(fromReminder ? todayDate : (existingStatusDate || todayDate));

    setConfirmationDate(formatDateForInput(loadedEmployee.confirmationDate));
    setNextIncrementDate(formatDateForInput(loadedEmployee.nextIncrementDate));
    setEligiblePromotion(loadedEmployee.eligiblePromotion || "");
    setEmploymentType(loadedEmployee.employmentType || "");
    setProfileImage(loadedEmployee.profileImage || null);
    setReportingManagerEmpID(loadedEmployee.reportingManagerEmpID || "");
    setReportingManagerEmployeeUserId(loadedEmployee.reportingManagerEmployeeUserId || "");
    setReportingManager(loadedEmployee.reportingManager || "");
    setDepartmentHeadEmpID(loadedEmployee.departmentHeadEmpID || "");
    setDepartmentHeadEmployeeUserId(loadedEmployee.departmentHeadEmployeeUserId || "");
    setdepartmentHead(loadedEmployee.departmentHead || "");

    // ==========================================
    // 5. ARRAY MAPPINGS (EXPLICITLY POPULATING ARRAYS)
    // ==========================================
    
    // Education Details
    if (Array.isArray(loadedEmployee.educationDetails) && loadedEmployee.educationDetails.length > 0) {
      setEducationDetails(loadedEmployee.educationDetails);
    } else {
      setEducationDetails([createEducationRow()]);
    }

    // Work Experience Details
    if (Array.isArray(loadedEmployee.experienceDetails) && loadedEmployee.experienceDetails.length > 0) {
      setExperienceDetails(
        loadedEmployee.experienceDetails.map((row) => ({
          ...row,
          id: row.id || row._id || `${Date.now()}-${Math.random().toString(16).slice(2)}`,
          totalDuration: row.totalDuration || calculateDurationLabel(row.startMonth, row.endMonth),
        }))
      );
    } else {
      setExperienceDetails([createExperienceRow()]);
    }

    // Nominees Details (Maps backend 'relationship' to frontend 'relation')
    if (Array.isArray(loadedEmployee.nominees) && loadedEmployee.nominees.length > 0) {
      setNomineeDetails(
        loadedEmployee.nominees.map((n) => ({
          name: n.name || "",
          relation: n.relationship || n.relation || "",
          share: n.share || "",
          age: n.age || "",
          address: n.address || "",
          dob: formatDateForInput(n.dob) || "",
        }))
      );
    } else {
      setNomineeDetails([createNomineeRow()]);
    }

    // Medical Details & Emergency Contact
    setBloodGroup(loadedEmployee.medical?.bloodGroup || "");
    setEyeSightLeft(loadedEmployee.medical?.eyeSightLeft || "");
    setEyeSightRight(loadedEmployee.medical?.eyeSightRight || "");
    setFamilyPlanStatus(loadedEmployee.medical?.familyPlanStatus || "");
    setFamilyPlanDate(formatDateForInput(loadedEmployee.medical?.familyPlanDate) || "");
    setHeight(loadedEmployee.medical?.height || "");
    setWeight(loadedEmployee.medical?.weight || "");
    setIdentificationMark1(loadedEmployee.medical?.identification1 || "");
    setIdentificationMark2(loadedEmployee.medical?.identification2 || "");
    setPhysicallyChallenged(loadedEmployee.medical?.physicallyChallenged || "");

    if (Array.isArray(loadedEmployee.emergencyContact) && loadedEmployee.emergencyContact.length > 0) {
      setEmergencyContact(
        loadedEmployee.emergencyContact.map(ec => ({
          name: ec.name || "",
          relation: ec.relation || "",
          mobile: ec.mobile || "",
          address: ec.address || ""
        }))
      );
    } else {
      setEmergencyContact([createEmergencyContactRow()]);
    }

    // Addresses
    setPermanentAddress(loadedEmployee.permanentAddress || {});
    setPresentAddress(loadedEmployee.presentAddress || {});

    // Pay Details & Bank info
    setBasicPay(loadedEmployee.payDetails?.basicPay || "");
    setPfType(loadedEmployee.payDetails?.pfType || "");
    setPassportNo(loadedEmployee.payDetails?.passportNo || "");
    setPfNo(loadedEmployee.payDetails?.pfNo || "");
    setUanNo(loadedEmployee.payDetails?.uanNo || "");
    setEsiNo(loadedEmployee.payDetails?.esiNo || "");
    setPanNo(loadedEmployee.payDetails?.panNo || "");
    setAadhaarNo(loadedEmployee.payDetails?.aadhaarNo || "");

    const primaryBank = loadedEmployee.payDetails?.primaryBank || {};
    const pBankName = String(primaryBank.bankName || loadedEmployee.payDetails?.bankName || "").trim().toUpperCase();
    if (pBankName && !BANK_OPTIONS.includes(pBankName)) {
      setPrimaryBankName("OTHERS");
      setPrimaryCustomBankName(pBankName);
    } else {
      setPrimaryBankName(pBankName);
      setPrimaryCustomBankName("");
    }
    setPrimaryBranch(primaryBank.branch || loadedEmployee.payDetails?.branch || "");
    setPrimaryIfscCode(primaryBank.ifscCode || loadedEmployee.payDetails?.ifscCode || "");
    setPrimaryAccountNo(primaryBank.accountNo || loadedEmployee.payDetails?.accountNo || "");

    const secondaryBank = loadedEmployee.payDetails?.secondaryBank || {};
    const sBankName = String(secondaryBank.bankName || "").trim().toUpperCase();
    if (sBankName && !BANK_OPTIONS.includes(sBankName)) {
      setSecondaryBankName("OTHERS");
      setSecondaryCustomBankName(sBankName);
    } else {
      setSecondaryBankName(sBankName);
      setSecondaryCustomBankName("");
    }
    setSecondaryBranch(secondaryBank.branch || "");
    setSecondaryIfscCode(secondaryBank.ifscCode || "");
    setSecondaryAccountNo(secondaryBank.accountNo || "");

    setPayType(loadedEmployee.payType || 'SALARY');
    setGrossSalary(loadedEmployee.grossSalary || "");

    if (Array.isArray(loadedEmployee.earnings) && loadedEmployee.earnings.length > 0) {
      setEarningDetails(loadedEmployee.earnings);
    }
    if (Array.isArray(loadedEmployee.deductions) && loadedEmployee.deductions.length > 0) {
      setDeductionDetails(loadedEmployee.deductions);
    }

    // Hard Copy Documents Conversion to Checkbox Object
    const hardCopyDocsObj = {};
    const docKeys = [
      "aadhaar", "pan", "bank", "photograph", "addressProof", "educationCertificates",
      "experienceLetters", "relievingLetter", "salarySlips", "medicalFitness",
      "policeVerification", "vaccinationCertificate", "bloodGroupProof", "nominationForm",
      "pfForm", "esiForm", "nda"
    ];
    docKeys.forEach(key => {
      if (Array.isArray(loadedEmployee.hardCopyDocuments)) {
        hardCopyDocsObj[key] = loadedEmployee.hardCopyDocuments.includes(key);
      } else if (
        loadedEmployee.hardCopyDocuments &&
        typeof loadedEmployee.hardCopyDocuments === "object"
      ) {
        hardCopyDocsObj[key] = Boolean(loadedEmployee.hardCopyDocuments[key]);
      } else {
        hardCopyDocsObj[key] = false;
      }
    });

    setEmployeeData(prev => ({
      ...prev,
      ...loadedEmployee,
      hardCopyDocuments: hardCopyDocsObj,
    }));
  }
}, [loadedEmployee, departments, designations, employees, fromReminder]);



  const handleDobChange = (val) => {
    setDob(val);
    if (val) {
      const dobDate = new Date(val);
      dobDate.setFullYear(dobDate.getFullYear() + 60);
      setDor(dobDate.toISOString().split("T")[0]);
    } else setDor("");
  };

  useEffect(() => {
   // fetchNextEmployeeID();
    loadMasters();
    fetchEmployees();
  }, []);

const fetchNextEmployeeID = async () => {
  try {
    const token = localStorage.getItem("token");
    const res = await axios.get("/api/employees/next-id", {
      headers: { Authorization: `Bearer ${token}` }
    });
    setEmployeeID(res.data.nextEmployeeID);
  } catch (err) {
    toast.error("Failed to get next employee ID", err);
  }
};


const loadMasters = async () => {
  try {
    const token = localStorage.getItem("token");
    const headers = { Authorization: `Bearer ${token}` };
    const [deptRes, desigRes, qualRes] = await Promise.all([
      axios.get("/api/departments", { headers }),
      axios.get("/api/designations", { headers }),
      axios.get("/api/master/qualifications", { headers }),
    ]);

   setDepartments(
  (deptRes.data || []).map((d) => ({
    value: d._id,
    label: d.deptName,
    _id: d._id,
    deptName: d.deptName
  }))
);

setDesignations(
  (desigRes.data || []).map((d) => ({
    value: d._id,
    label: d.designationName,
    _id: d._id,
    designationName: d.designationName,
    departmentName: d.departmentName 
  }))
);
setQualificationsMaster(qualRes.data || []);

  } catch (err) {
    toast.error("Error fetching master data:", err);
  }
};

const fetchEmployees = async () => {
  try {
    const token = localStorage.getItem("token");
    const res = await axios.get("/api/employees", {
      headers: { Authorization: `Bearer ${token}` }
    });
    setEmployees(res.data); // store all employees
  } catch (err) {
    toast.error("Failed to fetch employees:", err);
  }
};


useEffect(() => {
  if (employeeID) {
    const match = employeeID.match(/\d+$/); 
    
    if (match) {
      const numericPart = match[0];
      setEmployeeUserId(`DH-${numericPart}`);
    }
  }
}, [employeeID]);

const calculatePayStructure = (grossInput, currentPayType = payType) => {

  if (!grossInput || grossInput === "") {
    setGrossSalary("");
    setEarningDetails([]);
    setDeductionDetails([]);
    return;
  }

  const S = Math.round(parseFloat(grossInput) || 0);
  setGrossSalary(S);

  if (currentPayType === "Stipend") {
    /* ================= STIPEND LOGIC ================= */
    setEarningDetails([
      { headName: "Stipend Amount", headType: "EARNING", value: S }
    ]);
    setDeductionDetails([]);
  } else {
    /* ================= SALARY (SALARY) LOGIC ================= */
    const basic = Math.round(S * 0.50);
    const hra = Math.round(basic * 0.40);
    const mobile = S > 0 ? 500 : 0;
    const bonus = Math.round(basic / 6);
    const managementAllowance = S > 0 ? Math.round(S - (basic + hra + mobile + bonus)) : 0;
    const isPhysicallyChallenged = String(physicallyChallenged || "").toLowerCase() === "yes";
    const esiLimit = isPhysicallyChallenged ? 25000 : 21000;
    const esiAmount = S > 0 && S <= esiLimit ? Math.round(S * 0.0075) : 0;

    setEarningDetails([
      { headName: "Basic", headType: "EARNING", value: basic },
      { headName: "HRA", headType: "EARNING", value: hra },
      { headName: "Mobile Allowance", headType: "EARNING", value: mobile },
      { headName: "Bonus", headType: "EARNING", value: bonus },
      { headName: "Management Allowance", headType: "EARNING", value: managementAllowance },
    ]);

    setDeductionDetails([
      { headName: "PF", headType: "DEDUCTION", value: Math.round(basic * 0.12) },
      { headName: "PT", headType: "DEDUCTION", value: Math.round(S > 25000 ? 208 : (S >= 15000 ? 180 : 0)) },
      { headName: "ESI", headType: "DEDUCTION", value: esiAmount }
    ]);
  }
};

useEffect(() => {
  if (payType === "SALARY" && grossSalary !== "" && grossSalary !== null) {
    calculatePayStructure(grossSalary, payType);
  }
}, [physicallyChallenged, payType]);

  const handleFileChange = (e) => setProfileImage(e.target.files[0]);

  const handleAddRow = () =>
    setEducationDetails([...educationDetails, createEducationRow()]);

  const handleRemoveRow = (index) => {
    const updated = [...educationDetails];
    updated.splice(index, 1);
    setEducationDetails(updated);
  };

  const handleEduChange = (index, field, value) => {
    const updated = [...educationDetails];
    updated[index][field] = value;
    setEducationDetails(updated);
  };
  const calculateDurationLabel = (startMonth, endMonth) => {
    if (!startMonth || !endMonth) return "";
    const [sy, sm] = startMonth.split("-").map(Number);
    const [ey, em] = endMonth.split("-").map(Number);
    if (!sy || !sm || !ey || !em) return "";
    const diffMonths = (ey - sy) * 12 + (em - sm);
    if (diffMonths < 0) return "";
    const totalMonths = diffMonths + 1;
    const years = Math.floor(totalMonths / 12);
    const months = totalMonths % 12;
    const yearLabel = years > 0 ? `${years} year${years > 1 ? "s" : ""}` : "";
    const monthLabel = `${months} month${months !== 1 ? "s" : ""}`;
    return `${yearLabel}${yearLabel ? " " : ""}${monthLabel}`.trim();
  };
  const getMonthIndex = (monthStr) => {
    if (!monthStr) return null;
    const [y, m] = monthStr.split("-").map(Number);
    if (!y || !m) return null;
    return y * 12 + (m - 1);
  };
  const getExperienceTotalMonths = (startMonth, endMonth) => {
    const startIdx = getMonthIndex(startMonth);
    const endIdx = getMonthIndex(endMonth);
    if (startIdx == null || endIdx == null) return 0;
    const diff = endIdx - startIdx;
    if (diff < 0) return 0;
    return diff + 1;
  };
  const formatTotalMonths = (totalMonths) => {
    if (!totalMonths || totalMonths <= 0) return "";
    const years = Math.floor(totalMonths / 12);
    const months = totalMonths % 12;
    const yearLabel = years > 0 ? `${years} year${years > 1 ? "s" : ""}` : "";
    const monthLabel = `${months} month${months !== 1 ? "s" : ""}`;
    return `${yearLabel}${yearLabel ? " " : ""}${monthLabel}`.trim();
  };
  const handleExperienceChange = (id, field, value) => {
    setExperienceDetails((prev) => {
      const updated = prev.map((row) =>
        row.id === id ? { ...row, [field]: value } : row
      );
      return updated.map((row) =>
        row.id === id
          ? {
              ...row,
              totalDuration: calculateDurationLabel(row.startMonth, row.endMonth),
            }
          : row
      );
    });
  };
  const addExperienceRow = () =>
    setExperienceDetails((prev) => [createExperienceRow(), ...prev]);
  const removeExperienceRow = (id) =>
    setExperienceDetails((prev) => prev.filter((row) => row.id !== id));
const getValue = (obj) => {
  if (!obj) return "";
  if (typeof obj === "object") return obj.value || obj._id || "";
  return obj;
};

const getEmployeeName = (id) => {
  const emp = employees.find(e => e._id === id || e.employeeID === id || e.employeeUserId === id);
  if (!emp) return "";
  return [emp.firstName, emp.middleName, emp.lastName].filter(Boolean).join(" ");
};

const payload = {
  employeeID,
 employeeUserId,
  employmentStatus,
  exEmployeeReason: employmentStatus === "EX" ? exEmployeeReason : "",
  governmentRegistrationNumber,
  registrationState,
  salutation,
  firstName,
  middleName,
  lastName,
  fatherName,
  spouseName,
  caste,
  subCaste,
  religion,
  gender,
  maritalStatus,
  skillCategory,
  personalEmail: String(personalEmail || "").toLowerCase(),
  personalMobile,
  departmentID: departmentID,
  designationID: designationID,
  dob: formatDateForStorage(dob),
  dor: formatDateForStorage(dor),
  doj: formatDateForStorage(doj),
  statusChangeDate: formatDateForStorage(statusChangeDate),
  confirmationDate: formatDateForStorage(confirmationDate),
  nextIncrementDate: formatDateForStorage(nextIncrementDate),
  eligiblePromotion,
  employmentType,
  profileImage,
  reportingManager: reportingManager || getEmployeeName(reportingManagerEmpID),
  reportingManagerEmpID: reportingManagerEmpID,
  reportingManagerEmployeeUserId: reportingManagerEmployeeUserId,
  departmentHead: departmentHead || getEmployeeName(departmentHeadEmpID),
  departmentHeadEmpID: departmentHeadEmpID,
  departmentHeadEmployeeUserId: departmentHeadEmployeeUserId,
  educationDetails,
  experienceDetails: experienceDetails
    .map((row) => ({
      ...row,
      totalDuration: calculateDurationLabel(row.startMonth, row.endMonth),
    }))
    .filter((row) => {
      const { organizationName, organizationType, designation, employmentType, location, startMonth, endMonth } = row;
      return (
        organizationName ||
        organizationType ||
        designation ||
        employmentType ||
        location ||
        startMonth ||
        endMonth
      );
    })
    .sort((a, b) => {
      const aIdx = getMonthIndex(a.endMonth) ?? getMonthIndex(a.startMonth) ?? -1;
      const bIdx = getMonthIndex(b.endMonth) ?? getMonthIndex(b.startMonth) ?? -1;
      return bIdx - aIdx;
    })
    .map(({ id, ...rest }) => rest),
  nominees: nomineeDetails.map(n => ({
  name: n.name,
  relationship: n.relation, // map frontend 'relation' to backend 'relationship'
  dob: formatDateForStorage(n.dob),
  share: n.share,
  address: n.address
})),
  emergencyContact: emergencyContact.filter((c) => {
    const { name, relation, mobile, address } = c;
    return name || relation || mobile || address;
  }),

  medical: {
    bloodGroup,
    eyeSightLeft,
    eyeSightRight,
    familyPlanStatus,
    familyPlanDate: formatDateForStorage(familyPlanDate),
    height,
    weight,
    identification1: identificationMark1,
    identification2: identificationMark2,
    physicallyChallenged,
  },
  permanentAddress: { ...permanentAddress, mobile: "", email: "" },
  presentAddress: { ...presentAddress, mobile: "", email: "" },
payDetails: {
  basicPay,
  pfType,
  passportNo,
  pfNo,
  uanNo,
  esiNo,
  panNo,
  primaryBank: {
    bankName: primaryBankName === "OTHERS" ? primaryCustomBankName : primaryBankName,
    branch: primaryBranch,
    ifscCode: primaryIfscCode,
    accountNo: primaryAccountNo,
  },
  secondaryBank: {
    bankName: secondaryBankName === "OTHERS" ? secondaryCustomBankName : secondaryBankName,
    branch: secondaryBranch,
    ifscCode: secondaryIfscCode,
    accountNo: secondaryAccountNo,
  },
  payLevel,
  aadhaarNo,
},
  payType,
  grossSalary: Math.round(Number(grossSalary) || 0),
  earnings: earningDetails.map(e => ({
    ...e,
    value: Math.round(Number(e.value) || 0)
  })),
 deductions: deductionDetails.map(d => ({
    ...d,
    value: Math.round(Number(d.value) || 0)
  })),
  hardCopyDocuments: employeeData.hardCopyDocuments,

};

const handleSaveAndNext = async () => {
  if (activeEmployeeId && isLoadingFullEmployee) {
    toast.error("Please wait until full employee details load");
    return;
  }

  try {
    const token = localStorage.getItem("token");
    const config = { headers: { Authorization: `Bearer ${token}` } };
    const cleanedEdu = educationDetails.map(edu => ({
      ...edu,
      qualification: edu.qualification === "OTHER_SELECTED" ? "" : edu.qualification
    }));
    const finalData = { ...payload, educationDetails: cleanedEdu };

    // Use the current edit selection first, falling back to a newly created id.
    const activeId = activeEmployeeId || employeeData._id;

    if (activeId) {
      // UPDATE (PUT) - Existing employee being edited
      await axios.put(`/api/employees/${activeId}`, finalData, config);
    } else {
      // CREATE (POST) - Brand new employee only
      const res = await axios.post("/api/employees", finalData, config);
      const newEmp = res.data?.data || res.data;
      if (newEmp?._id) {
        setEmployeeData((prev) => ({ ...prev, _id: newEmp._id }));
      }
    }

    localStorage.setItem("employeeID", employeeID);
    setStep(step + 1); // Move to next step safely
  } catch (err) {
    console.error("Save & Next error:", err);
    if (err.response && err.response.data && err.response.data.error) {
      toast.error(err.response.data.error);
    } else {
      toast.error("Failed to save step");
    }
  }
};

const handleSubmit = async (e) => {
  e.preventDefault();

  if (activeEmployeeId && isLoadingFullEmployee) {
    toast.error("Please wait until full employee details load");
    return;
  }

  try {
    const token = localStorage.getItem("token");
    const config = { headers: { Authorization: `Bearer ${token}` } };
    const cleanedEduSubmit = educationDetails.map(edu => ({
      ...edu,
      qualification: edu.qualification === "OTHER_SELECTED" ? "" : edu.qualification
    }));
    const finalDataSubmit = { ...payload, educationDetails: cleanedEduSubmit };

    // Use the current edit selection or employeeData._id to determine if it's an update
    const targetId = activeEmployeeId || employeeData._id;

    if (targetId) {
      // UPDATE (PUT)
      await axios.put(`/api/employees/${targetId}`, finalDataSubmit, config);
      toast.success("Employee updated successfully!");
    } else {
      // CREATE (POST) - Only for brand new employees
      const res = await axios.post("/api/employees", finalDataSubmit, config);
      setEmployeeData(res.data); 
      toast.success("Employee saved successfully!");
    }

    // Return cleanly back to the table list view
    fetchEmployeeList();
    setSelectedEmployeeId("");
    setLoadedEmployee(null);
    setShowTableList(true);
  } catch (err) {
    if (err.response && err.response.data && err.response.data.error) {
      toast.error(err.response.data.error);
    } else {
      toast.error("Failed to save employee");
    }
  }
};



  return (
    <div className={masterBodyArea}>
        <Sidebar />
        <div className={`${masterPageShell} ${masterContentArea}`}>
          
        <header className={masterHeader}>
          <div className={masterHeaderCard}>
            <div className={masterHeaderInfo}>
              <div className={masterHeaderIcon}><Users size={14} /></div>
              <div><h1 className={masterTitle}>Employee Master</h1></div>
            </div>
            <button 
              type="button"
              onClick={() => {
                if (showTableList) {
                  // Switch to Add New / Form view
                  setSelectedEmployeeId("");
                  setLoadedEmployee(null);
                  setReportingManager("");
                  setReportingManagerEmpID("");
                  setReportingManagerEmployeeUserId("");
                  setdepartmentHead("");
                  setDepartmentHeadEmpID("");
                  setDepartmentHeadEmployeeUserId("");
                  setStep(1);
                  setShowTableList(false);
                } else {
                  // Switch back to Table List view
                  setSelectedEmployeeId("");
                  setLoadedEmployee(null);
                  setShowTableList(true);
                }
              }} 
              className={showTableList ? masterAccentButton : masterPrimaryButton}
            >
              {showTableList ? <><Plus size={10} /> ADD EMPLOYEE</> : <><ArrowLeft size={10} /> VIEW LIST</>}
            </button>
          </div>
        </header>

         <main className={`${masterTableBody} mt-1 w-full`}>
    {showTableList ? (
      /* ================= TABLE LIST VIEW ================= */
      <div className={`${masterPanel} flex flex-col overflow-hidden w-full h-full`}>
      <div className="border-b border-slate-200 flex-shrink-0 bg-white p-1 flex flex-wrap gap-3 items-center justify-between">
          <div className="flex items-center gap-3 flex-1 min-w-[300px]">
            {/* Status Filter Dropdown on the Left */}
            <select
              value={selectedStatus}
              onChange={(e) => {
                setSelectedStatus(e.target.value);
                setCurrentPage(1);
              }}
              className={masterSelect}
              style={{ width: '160px' }}
            >
              <option value="ALL">All Statuses</option>
              <option value="TP">Trainee Probation</option>
              <option value="TR">Trainee</option>
              <option value="TEP">TEP</option>
              <option value="PB">Probation</option>
              <option value="P">Permanent</option>
              <option value="PDP">PDP</option>
              <option value="PD">PD</option>
              <option value="EX">Ex-Employee</option>
            </select>

            {/* Search Bar next to it */}
            <div className="flex-1">
              <SearchBar 
                value={searchTerm} 
                onChange={(val) => {
                  setSearchTerm(val);
                  setCurrentPage(1);
                }} 
                placeholder="Search by name or employee ID..." 
                totalItems={filteredEmployees.length} 
                currentPage={currentPage} 
                pageSize={pageSize} 
                onPageChange={setCurrentPage} 
                onPageSizeChange={setPageSize} 
              />
            </div>
          </div>
        </div>

        <div className="overflow-x-auto w-full flex-1">
          <table className={masterTable}>
            <thead>
              <tr className={masterStickyHeadRow}>
                <th className={masterTableData} style={{ width: '60px' }}>S.No</th>
                <th className={masterTableData}>Employee ID</th>
                <th className={masterTableData}>Full Name</th>
                <th className={masterTableData}>Department</th>
                <th className={masterTableData}>Mobile</th>
                <th className={masterTableDatastatus}>Status</th>
                <th className={masterTableDatastatus}>Actions</th>
              </tr>
            </thead>
            <tbody className={masterTbody}>
              {paginatedEmployees.length > 0 ? (
                paginatedEmployees.map((emp, index) => (
                  <tr key={emp._id} className={masterTableRow}>
                    <td className={masterTableCell}>
                      {pageSize === -1 ? index + 1 : (currentPage - 1) * pageSize + index + 1}
                    </td>
                    <td className={masterTableCell}>{emp.employeeID}</td>
                    <td className={masterTableCell}>{`${emp.firstName || ''} ${emp.lastName || ''}`}</td>
                    <td className={masterTableCell}>{emp.departmentName || '--'}</td>
                    <td className={masterTableCell}>{emp.personalMobile || '--'}</td>
                    <td className={masterTableCellstatus}>
                      <span className={emp.employmentStatus !== 'EX' ? masterActiveColor : masterInactiveColor}>
                        {emp.employmentStatus || 'Active'}
                      </span>
                    </td>
                   <td className={masterTableCellstatus}>
                      <div className={masterActionButtonsContainer}>
                        <button 
                          type="button" 
                          onClick={() => {
                            setSelectedEmployeeId(emp._id || emp.employeeID || emp.employeeUserId);
                            setLoadedEmployee(null);
                            setIsLoadingFullEmployee(true);
                            setEditLoadKey((key) => key + 1);
                            setStep(1);
                            setShowTableList(false); // Switch to form in edit mode
                          }} 
                          className={masterEditButton}
                          title="Edit"
                        >
                          <Edit size={10} />
                        </button>
                        <button 
                          type="button" 
                          onClick={() => handleDelete(emp._id)} 
                          className={masterDeleteButton}
                          title="Delete"
                        >
                          <Trash2 size={10} />
                        </button>
                      </div>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="6" className="p-12 text-center text-slate-300 font-bold uppercase text-xs">
                    No records found
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    ) : (
            <div className={`${masterPanel} flex flex-col overflow-hidden w-full h-full p-4`}>
              
              <MobileHeaderToggle>
               <div className="bg-white flex items-center font-semibold gap-1 border-b border-slate-300 mb-3 pb-2 overflow-x-auto whitespace-nowrap scrollbar-hide px-1 text-xs sm:text-sm text-slate-700">
                {["Personal & Service details", "Work Experience", "Education", "Nominees/Medical/Address", "Pay Details", "Pay Structure","Document"].map((s, i) => (
                  <React.Fragment key={i}>
                    <div
                      className={`cursor-pointer px-2 py-0.5 rounded transition-all ${
                        step === i + 1 ? "bg-slate-800 text-white font-bold" : "text-slate-600 hover:text-slate-900"
                      }`}
                      onClick={() => setStep(i + 1)}
                    >
                      {s}
                    </div>
                    {i < 6 && (
                      <span className="text-slate-400 select-none">→</span>
                    )}
                  </React.Fragment>
                ))}
              </div>
              </MobileHeaderToggle>

              <div className="flex-1 overflow-y-auto min-h-0 pr-1">
              {step === 1 && (
                <>
                  <h3 className="text-sm font-bold text-slate-700 uppercase mb-3">
                    Personal Details
                  </h3>

                 <form onSubmit={handleSubmit} className={masterFormContainer}>
                   <div className={masterFormGrid5}>
                     <div className={masterFormGridRow}>
                      <Select
                          label="Employment Status *"
                          value={employmentStatus}
                          onChange={setEmploymentStatus}
                          options={[
                            { label: "TraineeProbation", value: "TP" },
                            { label: "Trainee", value: "TR" },
                            { label: "TEP", value: "TEP" },
                            { label: "Probation", value: "PB" },
                            { label: "Permanent", value: "P" },
                            { label: "PDP", value: "PDP" },
                            { label: "PD", value: "PD" },
                            { label: "ExEmployee", value: "EX" },
                          ]}
                        />
                     </div>
                     {employmentStatus === "EX" && (
                       <div className={masterFormGridRow}>
                        <Input
                          label="Ex Employee Reason"
                          value={exEmployeeReason}
                          onChange={setExEmployeeReason}
                        />
                       </div>
                     )}
                     <div className={masterFormGridRow}>
                      <Input 
                        label="Employee ID" 
                        value={employeeID} 
                        onChange={(val) => setEmployeeID(val)} 
                      />
                     </div>
                     <div className={masterFormGridRow}>
                      <Input 
                        label="Employee UserID" 
                        value={employeeUserId} 
                        readOnly={true} 
                      />
                     </div>
                     <div className={masterFormGridRow}>
                      <Input
                        label="Gov. Registration Number"
                        value={governmentRegistrationNumber}
                        onChange={(val) => setGovernmentRegistrationNumber(val.toUpperCase())}
                      /> 
                     </div>
                     <div className={masterFormGridRow}>
                      <Input
                        label="Registration State"
                        value={registrationState}
                        onChange={(val) => setregistrationState(val.toUpperCase())}
                      />
                     </div>
                     <div className={masterFormGridRow}>
                      <Select
                        label="Salutation"
                        value={salutation}
                        onChange={setSalutation}
                        options={["Mr.", "Mrs.", "Ms.", "Dr."]}
                      />
                     </div>
                     <div className={masterFormGridRow}>
                      <Input
                        label="First Name *"
                        value={firstName}
                        onChange={(val) =>
                          setFirstName(val.replace(/\s+/g, " ").trimStart().toUpperCase())
                        }
                      />
                     </div>
                     <div className={masterFormGridRow}>
                      <Input
                        label="Middle Name"
                        value={middleName}
                        onChange={(val) =>
                          setMiddleName(val.replace(/\s+/g, " ").trimStart().toUpperCase())
                        }
                      />
                     </div>
                     <div className={masterFormGridRow}>
                      <Input
                        label="Last Name"
                        value={lastName}
                        onChange={(val) =>
                          setLastName(val.replace(/\s+/g, " ").trimStart().toUpperCase())
                        }
                      />
                     </div>
                     <div className={masterFormGridRow}>
                      <Input
                        label="Father's Name *"
                        value={fatherName}
                        onChange={(val) => setFatherName(val.toUpperCase())}
                      />
                     </div>
                     <div className={masterFormGridRow}>
                      <Input
                        label="Spouse Name"
                        value={spouseName}
                        onChange={(val) => setSpouseName(val.toUpperCase())}
                      />
                     </div>
                     <div className={masterFormGridRow}>
                      <Input
                        label="Email"
                        type="email"
                        value={personalEmail}
                        onChange={(val) => setPersonalEmail(String(val || "").toLowerCase())}
                      />
                     </div>
                     <div className={masterFormGridRow}>
                      <Input
                        label="Mobile No."
                        value={personalMobile}
                        onChange={(val) => setPersonalMobile(val)}
                      />
                     </div>
                     <div className={masterFormGridRow}>
                      <Select
                        label="Caste"
                        value={caste}
                        onChange={setCaste}
                        options={[
                          "General",
                          "OBC-I",
                          "OBC-II",
                          "SC",
                          "ST",
                          "Other",
                        ]}
                      />
                     </div>
                     <div className={masterFormGridRow}>
                      <Select
                        label="Gender *"
                        value={gender}
                        onChange={setGender}
                        options={["Male", "Female", "Transgender", "Other"]}
                      />
                     </div>
                     <div className={masterFormGridRow}>
                      <Select
                        label="Religion"
                        value={religion}
                        onChange={setReligion}
                        options={["Hindu", "Muslim", "Christian", "Sikh", "Other"]}
                      />
                     </div>
                     <div className={masterFormGridRow}>
                      <Select
                        label="Marital Status"
                        value={maritalStatus}
                        onChange={setMaritalStatus}
                        options={["Yes", "No"]}
                      />
                     </div>
                     <div className={masterFormGridRow}>
                      <Select
                        label="Skill Category"
                        value={skillCategory}
                        onChange={setSkillCategory}
                        options={["Skilled", "Semi Skilled", "Unskilled"]}
                      />
                     </div>
                   </div>

                    <h3 className="text-sm font-bold text-slate-700 uppercase mt-4 mb-3 border-t pt-3 col-span-full">
                      Service Details
                    </h3>
                    <div className={masterFormGrid5}>
                      <div className={masterFormGridRow}>
                        <Select
                          label="Department *"
                          value={departmentID}
                          onChange={(val) => {
                            setDepartmentID(val);
                            const dept = departments.find(d => d._id === val);
                            setDepartmentName(dept?.deptName || "");
                            setSelectedDepartmentName(dept?.deptName || "");
                          }}
                          options={departments.map(dep => ({
                            label: dep.deptName,
                            value: dep._id
                          }))}
                        />
                      </div>
                      <div className={masterFormGridRow}>
                        <Select
                          label="Designation *"
                          value={designationID}
                          onChange={(val) => setDesignationID(val)}
                          options={filteredDesignations.map(des => ({
                            label: des.label,
                            value: des.value
                          }))}
                        />
                      </div>
                      <div className={masterFormGridRow}>
                        <Input
                          type="date"
                          label="Date of Birth *"
                          value={dob}
                          onChange={handleDobChange}
                          dateDisplayFormat="DD/MM/YYYY"
                        />
                      </div>
                      <div className={masterFormGridRow}>
                        <Input
                          type="date"
                          label="Date of Retirement"
                          readOnly
                          value={dor}
                          onChange={setDor}
                          dateDisplayFormat="DD/MM/YYYY"
                        />
                      </div>
                      <div className={masterFormGridRow}>
                        <Input
                          type="date"
                          label="Date of Joining *"
                          value={doj}
                          onChange={setDoj}
                          dateDisplayFormat="DD/MM/YYYY"
                        />
                      </div>
                      <div className={masterFormGridRow}>
                        <Input
                          type="date"
                          label="Employee Status Change Date"
                          value={statusChangeDate || doj}
                          onChange={setStatusChangeDate}
                          dateDisplayFormat="DD/MM/YYYY"
                        />
                      </div>
                      <div className={masterFormGridRow}>
                        <Input
                          type="date"
                          label="Confirmation Date"
                          value={confirmationDate}
                          onChange={setConfirmationDate}
                          dateDisplayFormat="DD/MM/YYYY"
                        />
                      </div>
                      <div className={masterFormGridRow}>
                        <Input
                          type="date"
                          label="Next Increment Date"
                          value={nextIncrementDate}
                          onChange={setNextIncrementDate}
                          dateDisplayFormat="DD/MM/YYYY"
                        />
                      </div>
                      <div className={masterFormGridRow}>
                        <Select
                          label="Eligible for Promotion"
                          value={eligiblePromotion}
                          onChange={setEligiblePromotion}
                          options={["Yes", "No"]}
                        />
                      </div>
                      <div className={masterFormGridRow}>
                        <SearchableSelect
                          label="Reporting Manager"
                          value={reportingManagerEmpID}
                          onChange={(val) => {
                            setReportingManagerEmpID(val);
                            const emp = employees.find((e) => e.employeeID === val);
                            if (emp) {
                              setReportingManager(`${emp.firstName} ${emp.lastName}`.trim());
                              setReportingManagerEmployeeUserId(emp.employeeUserId);
                            } else {
                              setReportingManager("");
                              setReportingManagerEmployeeUserId("");
                            }
                          }}
                          options={employees.map((e) => {
                            const fullName = `${e.firstName || ""} ${e.middleName || ""} ${e.lastName || ""}`
                              .replace(/\s+/g, " ")
                              .trim();
                            return {
                              value: e.employeeID,
                              label: `${fullName} (${e.employeeID})`,
                              searchText: fullName,
                            };
                          })}
                        />
                      </div>
                      <div className={masterFormGridRow}>
                        <SearchableSelect
                          label="Department Head"
                          value={departmentHeadEmpID}
                          onChange={(val) => {
                            setDepartmentHeadEmpID(val);
                            const emp = employees.find((e) => e.employeeID === val);
                            if (emp) {
                              setdepartmentHead(`${emp.firstName} ${emp.lastName}`.trim());
                              setDepartmentHeadEmployeeUserId(emp.employeeUserId);
                            } else {
                              setdepartmentHead("");
                              setDepartmentHeadEmployeeUserId("");
                            }
                          }}
                          options={employees.map((e) => {
                            const fullName = `${e.firstName || ""} ${e.middleName || ""} ${e.lastName || ""}`
                              .replace(/\s+/g, " ")
                              .trim();
                            return {
                              value: e.employeeID,
                              label: `${fullName} (${e.employeeID})`,
                              searchText: fullName,
                            };
                          })}
                        />
                      </div>
                    </div>

                   <div className={masterFormActionBlock}>
                     <BackButton />
                     <button
                       type="button"
                       onClick={handleSaveAndNext}
                       className={masterAccentButton}
                     >
                       <span>Save & Next</span>
                       <span>→</span>
                     </button>
                   </div>
                  </form>
                </>
              )}

              {/* ===================== STEP 2 ===================== */}
              {step === 2 && (
                <>
                  <div className="flex items-center justify-between flex-wrap gap-2 col-span-full mb-3">
                    <h3 className="text-sm font-bold text-slate-700 uppercase">
                      Work Experience
                    </h3>
                    <div className="text-xs font-semibold text-slate-600">
                      Total Experience:{" "}
                      {formatTotalMonths(
                        experienceDetails.reduce(
                          (sum, row) =>
                            sum + getExperienceTotalMonths(row.startMonth, row.endMonth),
                          0
                        )
                      ) || "--"}
                    </div>
                  </div>

                  <div className="overflow-x-auto mb-4">
                    <table className={masterTable}>
                      <thead>
                        <tr className={masterStickyHeadRow}>
                          <th className={masterTableData} style={{ width: '60px' }}>S.No.</th>
                          <th className={masterTableData}>Organization Name</th>
                          <th className={masterTableData}>Organization Type</th>
                          <th className={masterTableData}>Designation</th>
                          <th className={masterTableData}>Employment Type</th>
                          <th className={masterTableData}>Location</th>
                          <th className={masterTableData}>Start Month</th>
                          <th className={masterTableData}>End Month</th>
                          <th className={masterTableData}>Total Duration</th>
                          <th className={masterTableDatastatus}>Action</th>
                        </tr>
                      </thead>
                      <tbody className={masterTbody}>
                        {[...experienceDetails]
                          .sort((a, b) => {
                            const aIdx = getMonthIndex(a.endMonth) ?? getMonthIndex(a.startMonth) ?? -1;
                            const bIdx = getMonthIndex(b.endMonth) ?? getMonthIndex(b.startMonth) ?? -1;
                            return bIdx - aIdx;
                          })
                          .map((row, index) => (
                          <tr key={row.id} className={masterTableRow}>
                            <td className={masterTableCell} style={{ textAlign: 'center' }}>{index + 1}</td>
                            <td className={masterTableCell}>
                              <input
                                type="text"
                                value={row.organizationName}
                                onChange={(e) =>
                                  handleExperienceChange(
                                    row.id,
                                    "organizationName",
                                    e.target.value.toUpperCase()
                                  )
                                }
                                className={masterInput}
                              />
                            </td>
                            <td className={masterTableCell}>
                              <select
                                value={row.organizationType}
                                onChange={(e) =>
                                  handleExperienceChange(row.id, "organizationType", e.target.value)
                                }
                                className={masterSelect}
                              >
                                <option value="">Select</option>
                                <option value="Hospital">Hospital</option>
                                <option value="Clinic">Clinic</option>
                                <option value="Lab">Lab</option>
                                <option value="Pharmacy">Pharmacy</option>
                                <option value="Other Business">Other Business</option>
                              </select>
                            </td>
                            <td className={masterTableCell}>
                              <input
                                type="text"
                                value={row.designation}
                                onChange={(e) =>
                                  handleExperienceChange(
                                    row.id,
                                    "designation",
                                    e.target.value.toUpperCase()
                                  )
                                }
                                className={masterInput}
                              />
                            </td>
                            <td className={masterTableCell}>
                              <select
                                value={row.employmentType}
                                onChange={(e) =>
                                  handleExperienceChange(row.id, "employmentType", e.target.value)
                                }
                                className={masterSelect}
                              >
                                <option value="">Select</option>
                                <option value="Full-time">Full-time</option>
                                <option value="Part-time">Part-time</option>
                                <option value="Contract">Contract</option>
                                <option value="Internship">Internship</option>
                              </select>
                            </td>
                            <td className={masterTableCell}>
                              <input
                                type="text"
                                value={row.location}
                                onChange={(e) =>
                                  handleExperienceChange(
                                    row.id,
                                    "location",
                                    e.target.value.toUpperCase()
                                  )
                                }
                                className={masterInput}
                              />
                            </td>
                            <td className={masterTableCell}>
                              <input
                                type="month"
                                value={row.startMonth}
                                onChange={(e) =>
                                  handleExperienceChange(row.id, "startMonth", e.target.value)
                                }
                                className={masterInput}
                              />
                            </td>
                            <td className={masterTableCell}>
                              <input
                                type="month"
                                value={row.endMonth}
                                onChange={(e) =>
                                  handleExperienceChange(row.id, "endMonth", e.target.value)
                                }
                                className={masterInput}
                              />
                            </td>
                            <td className={masterTableCell} style={{ textAlign: 'center', fontWeight: 'bold' }}>
                              {row.totalDuration || "--"}
                            </td>
                            <td className={masterTableCellstatus}>
                              <div className={masterActionButtonsContainer}>
                              <button
                                type="button"
                                onClick={addExperienceRow}
                                className={masterPrimaryButton}
                              >
                                +
                              </button>
                                {experienceDetails.length > 1 && (
                                  <button
                                    type="button"
                                    onClick={() => removeExperienceRow(row.id)}
                                    className={masterDeleteButton}
                                  >
                                    -
                                  </button>
                                )}
                              </div>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>

                  <div className={masterFormActionBlock}>
                    <button
                      onClick={() => setStep(1)}
                      className={masterPrimaryButton}
                    >
                      ← Back
                    </button>
                    <button
                      type="button"
                      onClick={handleSaveAndNext}
                      className={masterAccentButton}
                    >
                      <span>Save & Next</span>
                    </button>
                  </div>
                </>
              )}

              {/* ===================== STEP 3 ===================== */}
              {step === 3 && (
                <>
                  <h3 className="text-sm font-bold text-slate-700 uppercase mb-3">
                    Educational Details
                  </h3>

                  <div className="overflow-x-auto mb-4">
                  <table className={masterTable}>
                    <thead className={masterStickyHeadRow}>
                      <tr>
                        <th className={masterTableData} style={{ width: '60px' }}>S.No.</th>
                        <th className={masterTableData}>Qualification</th>
                        <th className={masterTableData}>Discipline</th>
                        <th className={masterTableData}>Institute Name</th>
                        <th className={masterTableData}>Board/University</th>
                        <th className={masterTableData}>Year of Passing</th>
                        <th className={masterTableData}>Percentage</th>
                        <th className={masterTableData}>Grade/Division</th>
                        <th className={masterTableDatastatus}>Action</th>
                      </tr>
                    </thead>
                    <tbody className={masterTbody}>
                      {educationDetails.map((row, index) => (
                        <tr key={index} className={masterTableRow}>
                          <td className={masterTableCell} style={{ textAlign: 'center' }}>{index + 1}</td>
                        <td className={masterTableCell}>
                          <select
                            value={qualificationsMaster.some(q => q.qualName === row.qualification) ? row.qualification : (row.qualification === "" ? "" : "OTHER")}
                            onChange={(e) => {
                              const val = e.target.value;
                              if (val === "OTHER") {
                                handleEduChange(index, "qualification", "OTHER_SELECTED"); 
                              } else {
                                handleEduChange(index, "qualification", val);
                              }
                            }}
                            className={masterSelect}
                          >
                            <option value="">SELECT</option>
                            {qualificationsMaster
                              .filter(q => q.status === "Active")
                              .map((q) => (
                                <option key={q._id} value={q.qualName}>
                                  {q.qualName}
                                </option>
                              ))}
                            <option value="OTHER">OTHER</option>
                          </select>

                          {(row.qualification === "OTHER_SELECTED" || (!qualificationsMaster.some(q => q.qualName === row.qualification) && row.qualification !== "")) && (
                            <input
                              type="text"
                              placeholder="Specify Qualification"
                              value={row.qualification === "OTHER_SELECTED" ? "" : row.qualification}
                              onChange={(e) => handleEduChange(index, "qualification", e.target.value.toUpperCase())}
                              className={`${masterInput} mt-1`}
                            />
                          )}
                        </td>
                          <td className={masterTableCell}>
                            <input
                              type="text"
                              value={row.discipline}
                              onChange={(e) =>
                                handleEduChange(
                                  index,
                                  "discipline",
                                  e.target.value.toUpperCase()
                                )
                              }
                              className={masterInput}
                            />
                          </td>
                          <td className={masterTableCell}>
                            <input
                              type="text"
                              value={row.institute}
                              onChange={(e) =>
                                handleEduChange(
                                  index,
                                  "institute",
                                  e.target.value.toUpperCase()
                                )
                              }
                              className={masterInput}
                            />
                          </td>
                          <td className={masterTableCell}>
                            <input
                              type="text"
                              value={row.board}
                              onChange={(e) =>
                                handleEduChange(
                                  index,
                                  "board",
                                  e.target.value.toUpperCase()
                                )
                              }
                              className={masterInput}
                            />
                          </td>
                          <td className={masterTableCell}>
                            <input
                              type="text"
                              value={row.year}
                              onChange={(e) =>
                                handleEduChange(
                                  index,
                                  "year",
                                  e.target.value.toUpperCase()
                                )
                              }
                              className={masterInput}
                            />
                          </td>
                          <td className={masterTableCell}>
                            <input
                              type="text"
                              value={row.percentage}
                              onChange={(e) =>
                                handleEduChange(
                                  index,
                                  "percentage",
                                  e.target.value.toUpperCase()
                                )
                              }
                              className={masterInput}
                            />
                          </td>
                          <td className={masterTableCell}>
                            <input
                              type="text"
                              value={row.grade}
                              onChange={(e) =>
                                handleEduChange(
                                  index,
                                  "grade",
                                  e.target.value.toUpperCase()
                                )
                              }
                              className={masterInput}
                            />
                          </td>
                          <td className={masterTableCellstatus}>
                           <div className={masterActionButtonsContainer}>
                            <button
                              type="button"
                              onClick={handleAddRow}
                              className={masterPrimaryButton}
                            >
                              +
                            </button>
                            {educationDetails.length > 1 && (
                              <button
                                type="button"
                                onClick={() => handleRemoveRow(index)}
                                className={masterDeleteButton}
                              >
                                -
                              </button>
                            )}
                            </div>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                  <div className={masterFormActionBlock}>

                    <button
                      onClick={() => setStep(2)}
                      className={masterPrimaryButton}
                    >
                      ← Back
                    </button>

                    <button
                      type="button"
                      onClick={handleSaveAndNext}
                      className={masterAccentButton}
                    >
                      <span>Save & Next</span>
                      <span>→</span>
                    </button>

                  </div>
                  </div>
                </>
              )}

             {/* ===================== STEP 4 ===================== */}
              {step === 4 && (
                <>
                  <h3 className="text-sm font-bold text-slate-700 uppercase mb-3">
                    Nominee Details
                  </h3>
                  <div className="overflow-x-auto mb-4">
                    <table className={masterTable}>
                    <thead className={masterStickyHeadRow}>
                      <tr>
                        <th className={masterTableData} style={{ width: '60px' }}>S.No.</th>
                        <th className={masterTableData}>Name</th>
                        <th className={masterTableData}>Relation</th>
                        <th className={masterTableData}>Date of Birth</th>
                        <th className={masterTableData}>Share (%)</th>
                        <th className={masterTableDatastatus}>Action</th>
                      </tr>
                    </thead>
                    <tbody className={masterTbody}>
                      {nomineeDetails.map((row, index) => (
                        <tr key={index} className={masterTableRow}>
                          <td className={masterTableCell} style={{ textAlign: 'center' }}>{index + 1}</td>
                          <td className={masterTableCell}>
                            <input
                              type="text"
                              value={row.name}
                              onChange={(e) =>
                                setNomineeDetails((prev) => {
                                  const updated = [...prev];
                                  updated[index].name = e.target.value.toUpperCase();
                                  return updated;
                                })
                              }
                              className={masterInput}
                            />
                          </td>
                          <td className={masterTableCell}>
                            <input
                              type="text"
                              value={row.relation}
                              onChange={(e) =>
                                setNomineeDetails((prev) => {
                                  const updated = [...prev];
                                  updated[index].relation = e.target.value.toUpperCase();
                                  return updated;
                                })
                              }
                              className={masterInput}
                            />
                          </td>
                          <td className={masterTableCell}>
                          <DateDisplayInput
                            value={row.dob}
                            onChange={(val) =>
                              setNomineeDetails((prev) => {
                                const updated = [...prev];
                                updated[index].dob = val;
                                return updated;
                              })
                            }
                            className={masterInput}
                          />
                          </td>
                          <td className={masterTableCell}>
                            <input
                              type="number"
                              value={row.share}
                              onChange={(e) =>
                                setNomineeDetails((prev) => {
                                  const updated = [...prev];
                                  updated[index].share = e.target.value;
                                  return updated;
                                })
                              }
                              className={masterInput}
                            />
                          </td>
                         

                          <td className={masterTableCellstatus}>
                            <div className={masterActionButtonsContainer}>
                            <button
                              type="button"
                              onClick={() =>
                                setNomineeDetails([
                                  ...nomineeDetails,
                                  createNomineeRow(),
                                ])
                              }
                              className={masterPrimaryButton}
                            >
                              +
                            </button>
                            {nomineeDetails.length > 1 && (
                              <button
                                type="button"
                                onClick={() =>
                                  setNomineeDetails(nomineeDetails.filter((_, i) => i !== index))
                                }
                                className={masterDeleteButton}
                              >
                                -
                              </button>
                            )}
                            </div>
                          </td>

                        </tr>
                      ))}
                    </tbody>
                  </table>
                  </div>

                  <h3 className="text-sm font-bold text-slate-700 uppercase mt-4 mb-3">
                    Medical Information
                  </h3>

                  <div className={masterFormGrid5}>
                     <div className={masterFormGridRow}>
                      <label className={masterInputLabel}>Blood Group</label>
                      <select
                        value={bloodGroup}
                        onChange={(e) => setBloodGroup(e.target.value)}
                        className={masterSelect}
                      >
                        <option value="">Select</option>
                        <option value="A+">A+</option>
                        <option value="A-">A-</option>
                        <option value="B+">B+</option>
                        <option value="B-">B-</option>
                        <option value="O+">O+</option>
                        <option value="O-">O-</option>
                        <option value="AB+">AB+</option>
                        <option value="AB-">AB-</option>
                      </select>
                     </div>

                     <div className={masterFormGridRow}>
                      <label className={masterInputLabel}>Eye Sight (Left)</label>
                      <input
                        type="text"
                        value={eyeSightLeft}
                        onChange={(e) => setEyeSightLeft((e.target.value || "").toUpperCase())}
                        className={masterInput}
                      />
                     </div>

                     <div className={masterFormGridRow}>
                      <label className={masterInputLabel}>Eye Sight (Right)</label>
                      <input
                        type="text"
                        value={eyeSightRight}
                        onChange={(e) => setEyeSightRight((e.target.value || "").toUpperCase())}
                        className={masterInput}
                      />
                     </div>

                     <div className={masterFormGridRow}>
                      <label className={masterInputLabel}>Family Plan Status</label>
                      <select
                        value={familyPlanStatus}
                        onChange={(e) => setFamilyPlanStatus(e.target.value)}
                        className={masterSelect}
                      >
                        <option value="">Select</option>
                        <option value="Yes">Yes</option>
                        <option value="No">No</option>
                      </select>
                     </div>

                     <div className={masterFormGridRow}>
                      <label className={masterInputLabel}>Family Plan Date</label>
                      <DateDisplayInput
                        value={familyPlanDate}
                        onChange={setFamilyPlanDate}
                        className={masterInput}
                      />
                     </div>

                     <div className={masterFormGridRow}>
                      <label className={masterInputLabel}>Height (in cm)</label>
                      <input
                        type="number"
                        value={height}
                        onChange={(e) => setHeight(e.target.value)}
                        className={masterInput}
                      />
                     </div>

                     <div className={masterFormGridRow}>
                      <label className={masterInputLabel}>Weight (in Kgs)</label>
                      <input
                        type="number"
                        value={weight}
                        onChange={(e) => setWeight(e.target.value)}
                        className={masterInput}
                      />
                     </div>

                     <div className={masterFormGridRow}>
                      <label className={masterInputLabel}>Identification Mark (1)</label>
                      <input
                        type="text"
                        value={identificationMark1}
                        onChange={(e) =>
                          setIdentificationMark1((e.target.value || "").toUpperCase())
                        }
                        className={masterInput}
                      />
                     </div>

                     <div className={masterFormGridRow}>
                      <label className={masterInputLabel}>Identification Mark (2)</label>
                      <input
                        type="text"
                        value={identificationMark2}
                        onChange={(e) =>
                          setIdentificationMark2((e.target.value || "").toUpperCase())
                        }
                        className={masterInput}
                      />
                     </div>

                     <div className={masterFormGridRow}>
                      <label className={masterInputLabel}>Physically Challenged</label>
                      <select
                        value={physicallyChallenged}
                        onChange={(e) => setPhysicallyChallenged(e.target.value)}
                        className={masterSelect}
                      >
                        <option value="">Select</option>
                        <option value="Yes">Yes</option>
                        <option value="No">No</option>
                      </select>
                     </div>
                  </div>

                  <h3 className="text-sm font-bold text-slate-700 uppercase mt-4 mb-3">
                    Emergency Contact
                  </h3>

                  <div className="overflow-x-auto mb-4 col-span-full">
                    <table className={masterTable}>
                      <thead className={masterStickyHeadRow}>
                        <tr>
                          <th className={masterTableData} style={{ width: '60px' }}>S.No.</th>
                          <th className={masterTableData}>Contact Name</th>
                          <th className={masterTableData}>Relation</th>
                          <th className={masterTableData}>Emergency Contact No.</th>
                          <th className={masterTableData}>Address</th>
                          <th className={masterTableDatastatus}>Action</th>
                        </tr>
                      </thead>
                      <tbody className={masterTbody}>
                        {emergencyContact.map((row, index) => (
                          <tr key={index} className={masterTableRow}>
                            <td className={masterTableCell} style={{ textAlign: 'center' }}>{index + 1}</td>
                            <td className={masterTableCell}>
                              <input
                                type="text"
                                value={row.name}
                                onChange={(e) =>
                                  setEmergencyContact((prev) => {
                                    const updated = [...prev];
                                    updated[index].name = e.target.value.toUpperCase();
                                    return updated;
                                  })
                                }
                                className={masterInput}
                              />
                            </td>
                            <td className={masterTableCell}>
                              <input
                                type="text"
                                value={row.relation}
                                onChange={(e) =>
                                  setEmergencyContact((prev) => {
                                    const updated = [...prev];
                                    updated[index].relation = e.target.value.toUpperCase();
                                    return updated;
                                  })
                                }
                                className={masterInput}
                              />
                            </td>
                            <td className={masterTableCell}>
                              <input
                                type="text"
                                value={row.mobile}
                                onChange={(e) =>
                                  setEmergencyContact((prev) => {
                                    const updated = [...prev];
                                    updated[index].mobile = e.target.value;
                                    return updated;
                                  })
                                }
                                className={masterInput}
                              />
                            </td>
                            <td className={masterTableCell}>
                              <input
                                type="text"
                                value={row.address}
                                onChange={(e) =>
                                  setEmergencyContact((prev) => {
                                    const updated = [...prev];
                                    updated[index].address = e.target.value.toUpperCase();
                                    return updated;
                                  })
                                }
                                className={masterInput}
                              />
                            </td>
                            <td className={masterTableCellstatus}>
                              <div className={masterActionButtonsContainer}>
                                <button
                                  type="button"
                                  onClick={() =>
                                    setEmergencyContact((prev) => [
                                      ...prev,
                                      createEmergencyContactRow(),
                                    ])
                                  }
                                  className={masterPrimaryButton}
                                >
                                  +
                                </button>
                                {emergencyContact.length > 1 && (
                                  <button
                                    type="button"
                                    onClick={() =>
                                      setEmergencyContact((prev) =>
                                        prev.filter((_, i) => i !== index)
                                      )
                                    }
                                    className={masterDeleteButton}
                                  >
                                    -
                                  </button>
                                )}
                              </div>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>

                  <h3 className="text-sm font-bold text-slate-700 uppercase mt-4 mb-3">
                    Permanent Address
                  </h3>

                  <div className={masterFormGrid5}>
                     <div className={masterFormGridRow}>
                      <label className={masterInputLabel}>Street No. and Name</label>
                      <input
                        type="text"
                        value={permanentAddress.street || ""}
                        onChange={(e) =>
                          setPermanentAddress({
                            ...permanentAddress,
                            street: e.target.value.toUpperCase(),
                          })
                        }
                        className={masterInput}
                      />
                     </div>

                     <div className={masterFormGridRow}>
                      <label className={masterInputLabel}>Village/Town</label>
                      <input
                        type="text"
                        value={permanentAddress.village || ""}
                        onChange={(e) =>
                          setPermanentAddress({
                            ...permanentAddress,
                            village: e.target.value.toUpperCase(),
                          })
                        }
                        className={masterInput}
                      />
                     </div>

                     <div className={masterFormGridRow}>
                      <label className={masterInputLabel}>City</label>
                      <input
                        type="text"
                        value={permanentAddress.city || ""}
                        onChange={(e) =>
                          setPermanentAddress({
                            ...permanentAddress,
                            city: e.target.value.toUpperCase(),
                          })
                        }
                        className={masterInput}
                      />
                     </div>

                     <div className={masterFormGridRow}>
                      <label className={masterInputLabel}>Post Office</label>
                      <input
                        type="text"
                        value={permanentAddress.postOffice || ""}
                        onChange={(e) =>
                          setPermanentAddress({
                            ...permanentAddress,
                            postOffice: e.target.value.toUpperCase(),
                          })
                        }
                        className={masterInput}
                      />
                     </div>

                     <div className={masterFormGridRow}>
                      <label className={masterInputLabel}>Police Station</label>
                      <input
                        type="text"
                        value={permanentAddress.policeStation || ""}
                        onChange={(e) =>
                          setPermanentAddress({
                            ...permanentAddress,
                            policeStation: e.target.value.toUpperCase(),
                          })
                        }
                        className={masterInput}
                      />
                     </div>

                     <div className={masterFormGridRow}>
                      <label className={masterInputLabel}>Pin Code *</label>
                      <input
                        type="text"
                        value={permanentAddress.pinCode || ""}
                        onChange={(e) =>
                          setPermanentAddress({
                            ...permanentAddress,
                            pinCode: e.target.value.toUpperCase(),
                          })
                        }
                        className={masterInput}
                      />
                     </div>

                     <div className={masterFormGridRow}>
                      <label className={masterInputLabel}>District</label>
                      <input
                        type="text"
                        value={permanentAddress.district || ""}
                        onChange={(e) =>
                          setPermanentAddress({
                            ...permanentAddress,
                            district: e.target.value.toUpperCase(),
                          })
                        }
                        className={masterInput}
                      />
                     </div>

                     <div className={masterFormGridRow}>
                      <label className={masterInputLabel}>State *</label>
                      <select
                        value={permanentAddress.state || ""}
                        onChange={(e) =>
                          setPermanentAddress({
                            ...permanentAddress,
                            state: e.target.value.toUpperCase(),
                          })
                        }
                        className={masterSelect}
                      >
                        <option value="">Select</option>
                        <option value="ANDHRA PRADESH">Andhra Pradesh</option>
                        <option value="ARUNACHAL PRADESH">Arunachal Pradesh</option>
                        <option value="ASSAM">Assam</option>
                        <option value="BIHAR">Bihar</option>
                        <option value="CHHATTISGARH">Chhattisgarh</option>
                        <option value="GOA">Goa</option>
                        <option value="GUJARAT">Gujarat</option>
                        <option value="HARYANA">Haryana</option>
                        <option value="HIMACHAL PRADESH">Himachal Pradesh</option>
                        <option value="JHARKHAND">Jharkhand</option>
                        <option value="KARNATAKA">Karnataka</option>
                        <option value="KERALA">Kerala</option>
                        <option value="MADHYA PRADESH">Madhya Pradesh</option>
                        <option value="MAHARASHTRA">Maharashtra</option>
                        <option value="MANIPUR">Manipur</option>
                        <option value="MEGHALAYA">Meghalaya</option>
                        <option value="MIZORAM">Mizoram</option>
                        <option value="NAGALAND">Nagaland</option>
                        <option value="ODISHA">Odisha</option>
                        <option value="PUNJAB">Punjab</option>
                        <option value="RAJASTHAN">Rajasthan</option>
                        <option value="SIKKIM">Sikkim</option>
                        <option value="TAMIL NADU">Tamil Nadu</option>
                        <option value="TELANGANA">Telangana</option>
                        <option value="TRIPURA">Tripura</option>
                        <option value="UTTAR PRADESH">Uttar Pradesh</option>
                        <option value="UTTARAKHAND">Uttarakhand</option>
                        <option value="WEST BENGAL">West Bengal</option>
                        <option value="ANDAMAN AND NICOBAR">Andaman and Nicobar Islands</option>
                        <option value="CHANDIGARH">Chandigarh</option>
                        <option value="DADRA AND NAGAR HAVELI AND DAMAN AND DIU">Dadra and Nagar Haveli and Daman & Diu</option>
                        <option value="DELHI">Delhi</option>
                        <option value="JAMMU AND KASHMIR">Jammu & Kashmir</option>
                        <option value="LADAKH">Ladakh</option>
                        <option value="LAKSHADWEEP">Lakshadweep</option>
                        <option value="PUDUCHERRY">Puducherry</option>
                        <option value="OTHER">Other</option>
                      </select>
                     </div>

                     <div className={masterFormGridRow}>
                      <label className={masterInputLabel}>Country</label>
                      <input
                        type="text"
                        value={permanentAddress.country || "INDIA"}
                        onChange={(e) =>
                          setPermanentAddress({
                            ...permanentAddress,
                            country: e.target.value.toUpperCase(),
                          })
                        }
                        className={masterInput}
                      />
                     </div>
                  </div>

                  <div className="flex items-center justify-between mt-4 mb-2">
                    <h3 className="text-sm font-bold text-slate-700 uppercase">Present Address</h3>
                    <label className="flex items-center space-x-2 text-xs font-semibold text-slate-700">
                      <input
                        type="checkbox"
                        checked={sameAsPermanent}
                        onChange={(e) => {
                          const checked = e.target.checked;
                          setSameAsPermanent(checked);
                          if (checked) {
                            setPresentAddress(permanentAddress);
                          } else {
                            setPresentAddress({
                              street: "",
                              village: "",
                              city: "",
                              postOffice: "",
                              policeStation: "",
                              pinCode: "",
                              district: "",
                              state: "",
                              country: "INDIA",
                            });
                          }
                        }}
                      />
                      <span>Same as Permanent Address</span>
                    </label>
                  </div>

                  <div className={masterFormGrid5}>
                    {[
                      "street",
                      "village",
                      "city",
                      "postOffice",
                      "policeStation",
                      "pinCode",
                      "district",
                      "state",
                      "country",
                    ].map((field, i) => (
                      <div key={i} className={masterFormGridRow}>
                        <label className={masterInputLabel}>
                          {field === "pinCode"
                            ? "Pin Code *"
                            : field === "postOffice"
                            ? "Post Office"
                            : field === "policeStation"
                            ? "Police Station"
                            : field}
                        </label>
                        <input
                          type="text"
                          value={presentAddress[field] || ""}
                          onChange={(e) =>
                            setPresentAddress({
                              ...presentAddress,
                              [field]: e.target.value.toUpperCase(),
                            })
                          }
                          className={masterInput}
                        />
                      </div>
                    ))}
                  </div>

                  <div className={masterFormActionBlock}>
                    <button
                      onClick={() => setStep(3)}
                      className={masterPrimaryButton}
                    >
                      ← Back
                    </button>
                    <button
                      type="button"
                      onClick={handleSaveAndNext} 
                      className={masterAccentButton}
                    >
                      <span>Save & Next</span>
                      <span>→</span>
                    </button>
                  </div>
                </>
              )}

              {step === 5 && (
                <div className="bg-white p-1 w-full">
                  <h3 className="text-sm font-bold text-slate-700 uppercase mb-3">
                    Pay Details
                  </h3>

                  <div className={masterFormGrid5}>
                    <div className={masterFormGridRow}>
                      <Input label="Passport No." value={passportNo} onChange={setPassportNo} />
                    </div>
                    <div className={masterFormGridRow}>
                      <Input label="PF Member ID" value={pfNo} onChange={setPfNo} />
                    </div>
                    <div className={masterFormGridRow}>
                      <Input label="PF UAN" value={uanNo} onChange={setUanNo} />
                    </div>
                    <div className={masterFormGridRow}>
                      <Input label="ESI No." value={esiNo} onChange={setEsiNo} />
                    </div>
                    <div className={masterFormGridRow}>
                      <Input label="Pan No." value={panNo} onChange={setPanNo} />
                    </div>
                    <div className={masterFormGridRow}>
                      <Input label="Aadhar No." value={aadhaarNo} onChange={setAadhaarNo} />
                    </div>

                    <div className="col-span-full mt-2">
                      <h4 className="text-xs font-bold text-slate-700 uppercase border-b pb-1">Primary Bank Details</h4>
                    </div>

                    <div className={masterFormGridRow}>
                      <SearchableSelect
                        label="Primary Bank Name (*)"
                        value={primaryBankName}
                        onChange={(value) => {
                          setPrimaryBankName(value);
                          if (value !== "OTHERS") setPrimaryCustomBankName("");
                        }}
                        options={BANK_SELECT_OPTIONS}
                      />
                    </div>
                    {primaryBankName === "OTHERS" && (
                      <div className={masterFormGridRow}>
                        <Input
                          label="Other Primary Bank Name (*)"
                          placeholder="Enter Bank Name"
                          value={primaryCustomBankName}
                          onChange={setPrimaryCustomBankName}
                        />
                      </div>
                    )}

                    <div className={masterFormGridRow}>
                      <Input 
                        label="Primary Branch (*)" 
                        placeholder="Enter Branch Name" 
                        value={primaryBranch} 
                        onChange={(val) => setPrimaryBranch(val.toUpperCase())} 
                      />
                    </div>
                    <div className={masterFormGridRow}>
                      <Input label="Primary IFSC Code (*)" value={primaryIfscCode} onChange={setPrimaryIfscCode} />
                    </div>
                    <div className={masterFormGridRow}>
                      <Input label="Primary Account No. (*)" value={primaryAccountNo} onChange={setPrimaryAccountNo} />
                    </div>

                    <div className="col-span-full mt-4">
                      <h4 className="text-xs font-bold text-slate-700 uppercase border-b pb-1">Secondary Bank Details (Optional)</h4>
                    </div>

                    <div className={masterFormGridRow}>
                      <SearchableSelect
                        label="Secondary Bank Name"
                        value={secondaryBankName}
                        onChange={(value) => {
                          setSecondaryBankName(value);
                          if (value !== "OTHERS") setSecondaryCustomBankName("");
                        }}
                        options={BANK_SELECT_OPTIONS}
                      />
                    </div>
                    {secondaryBankName === "OTHERS" && (
                      <div className={masterFormGridRow}>
                        <Input
                          label="Other Secondary Bank Name"
                          placeholder="Enter Bank Name"
                          value={secondaryCustomBankName}
                          onChange={setSecondaryCustomBankName}
                        />
                      </div>
                    )}

                    <div className={masterFormGridRow}>
                      <Input 
                        label="Secondary Branch" 
                        placeholder="Enter Branch Name" 
                        value={secondaryBranch} 
                        onChange={(val) => setSecondaryBranch(val.toUpperCase())} 
                      />
                    </div>
                    <div className={masterFormGridRow}>
                      <Input label="Secondary IFSC Code" value={secondaryIfscCode} onChange={setSecondaryIfscCode} />
                    </div>
                    <div className={masterFormGridRow}>
                      <Input label="Secondary Account No." value={secondaryAccountNo} onChange={setSecondaryAccountNo} />
                    </div>
                  </div>

                  <div className={masterFormActionBlock}>
                      <button
                        onClick={() => setStep(4)}
                        className={masterPrimaryButton}
                      >
                        ← Back
                      </button>
                      <button
                        type="button"
                        onClick={handleSaveAndNext} 
                        className={masterAccentButton}
                      >
                        <span>Save & Next</span>
                        <span>→</span>
                      </button>
                  </div>
                </div>
              )}

              {/* ---------- STEP 6 : PAY STRUCTURE ---------- */}
              {step === 6 && (
                <div className="space-y-4">
                  <h3 className="text-sm font-bold text-slate-700 uppercase border-b pb-2">Pay Structure</h3>

                  <div className="flex items-center gap-6 bg-slate-50 p-3 rounded border border-slate-200">
                    <label className="font-bold text-xs text-slate-700 uppercase">Pay Type :</label>
                    <div className="flex gap-4">
                      <label className="flex items-center gap-2 cursor-pointer text-xs">
                        <input
                          type="radio"
                          name="payType"
                          value="SALARY"
                          checked={payType === 'SALARY'}
                          onChange={() => {
                            setPayType('SALARY');
                            calculatePayStructure("");
                          }}
                          className="w-4 h-4 text-slate-800"
                        />
                        <span className="font-medium">Salary</span>
                      </label>
                      <label className="flex items-center gap-2 cursor-pointer text-xs">
                        <input
                          type="radio"
                          name="payType"
                          value="Stipend"
                          checked={payType === 'Stipend'}
                          onChange={() => {
                            setPayType('Stipend');
                            calculatePayStructure("");
                          }}
                          className="w-4 h-4 text-slate-800"
                        />
                        <span className="font-medium">Stipend</span>
                      </label>
                    </div>
                  </div>

                  <div className="flex items-center gap-4 bg-slate-50 p-3 rounded border border-slate-200">
                    <label className="font-bold text-xs text-slate-700 uppercase">
                      {payType === 'Stipend' ? 'Enter Stipend Amount :' : 'Enter Gross Salary :'}
                    </label>
                    <input
                      type="number"
                      value={grossSalary || ''}
                      className={masterInput}
                      style={{ width: '200px' }}
                      placeholder={payType === 'Stipend' ? "e.g. 10000" : "e.g. 30000"}
                      onChange={(e) => calculatePayStructure(e.target.value)}
                    />
                  </div>

                  {payType === 'SALARY' ? (
                    <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
                      <div className="border rounded overflow-hidden shadow-sm">
                        <div className="bg-slate-800 text-white p-2 font-bold text-center text-xs uppercase">EARNINGS</div>
                        <table className={masterTable}>
                          <thead className={masterStickyHeadRow}>
                            <tr>
                              <th className={masterTableData}>Head Name</th>
                              <th className={masterTableData} style={{ textAlign: 'right' }}>Amount</th>
                            </tr>
                          </thead>
                          <tbody className={masterTbody}>
                            {earningDetails.map((item, index) => (
                              <tr key={index} className={masterTableRow}>
                                <td className={masterTableCell} style={{ fontWeight: 'bold' }}>{item.headName}</td>
                                <td className={masterTableCell}>
                                  <input
                                    type="number"
                                    value={item.value ? Math.round(item.value) : ''}
                                    className={`${masterInput} text-right`}
                                    onChange={(e) => {
                                      const updated = [...earningDetails];
                                      updated[index].value = e.target.value;
                                      setEarningDetails(updated);
                                    }}
                                  />
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>

                      <div className="border rounded overflow-hidden shadow-sm">
                        <div className="bg-red-700 text-white p-2 font-bold text-center text-xs uppercase">DEDUCTIONS</div>
                        <table className={masterTable}>
                          <thead className={masterStickyHeadRow}>
                            <tr>
                              <th className={masterTableData}>Head Name</th>
                              <th className={masterTableData} style={{ textAlign: 'right' }}>Amount</th>
                            </tr>
                          </thead>
                          <tbody className={masterTbody}>
                            {deductionDetails.map((item, index) => (
                              <tr key={index} className={masterTableRow}>
                                <td className={masterTableCell} style={{ fontWeight: 'bold' }}>{item.headName}</td>
                                <td className={masterTableCell}>
                                  <input
                                    type="number"
                                    value={item.value ? Math.round(item.value) : ''}
                                    className={`${masterInput} text-right`}
                                    onChange={(e) => {
                                      const updated = [...deductionDetails];
                                      updated[index].value = e.target.value;
                                      setDeductionDetails(updated);
                                    }}
                                  />
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  ) : (
                    <div className="p-6 border border-dashed border-slate-300 rounded text-center text-slate-500 italic text-xs">
                      Breakdown is not required for Stipend. The amount above will be recorded as a flat payment.
                    </div>
                  )}

                  <div className={masterFormActionBlock}>
                    <button
                      type="button"
                      onClick={() => setStep(5)}
                      className={masterPrimaryButton}
                    >
                      ← Back
                    </button>
                    <button
                      type="button"
                      onClick={handleSaveAndNext}
                      className={masterAccentButton}
                    >
                      Save & Next →
                    </button>
                  </div>
                </div>
              )}

              {/* ---------- STEP 7 : DOCUMENT MANAGEMENT ---------- */}
              {step === 7 && (
                <div className="bg-white p-1 w-full">
                  <h3 className="text-sm font-bold text-slate-700 uppercase mb-3">
                    Document Management
                  </h3>

                  <div className="border rounded p-3 mb-4">
                    <h4 className="text-xs font-bold text-slate-700 uppercase mb-3">
                      Hard Copy Documents Collected
                    </h4>

                    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-3 text-xs font-medium">
                      {[
                        ["aadhaar", "Aadhaar"],
                        ["pan", "PAN"],
                        ["bank", "Bank Passbook / Cheque"],
                        ["photograph", "Photograph"],
                        ["addressProof", "Address Proof"],
                        ["educationCertificates", "Education Certificates"],
                        ["experienceLetters", "Experience Letters"],
                        ["relievingLetter", "Relieving Letter"],
                        ["salarySlips", "Salary Slips"],
                        ["medicalFitness", "Medical Fitness"],
                        ["policeVerification", "Police Verification"],
                        ["vaccinationCertificate", "Vaccination Certificate"],
                        ["bloodGroupProof", "Blood Group Proof"],
                        ["pfForm", "PF Form"],
                        ["esiForm", "ESI Form"],
                        ["nda", "NDA / Agreement"],
                      ].map(([key, label]) => (
                        <label key={key} className="flex items-center gap-2 cursor-pointer">
                          <input
                            type="checkbox"
                            checked={employeeData.hardCopyDocuments?.[key] || false}
                            onChange={(e) =>
                              setEmployeeData({
                                ...employeeData,
                                hardCopyDocuments: {
                                  ...employeeData.hardCopyDocuments,
                                  [key]: e.target.checked,
                                },
                              })
                            }
                          />
                          <span>{label}</span>
                        </label>
                      ))}
                    </div>
                  </div>

                 <div className={masterFormActionBlock}>
                   <button
                        onClick={() => setStep(6)}
                        className={masterPrimaryButton}
                      >
                        ← Back
                    </button>
                    <form onSubmit={handleSubmit}>
                     <button
                        type="submit"
                        className={masterAccentButton}
                      >
                        <span>{activeEmployeeId ? "Update" : "Submit"}</span>
                        <span>→</span>
                      </button>
                    </form>
                  </div>
                </div>
              )}
              </div>
            </div>
    )}
          </main>
        </div>
    </div>
  );
};

const DateDisplayInput = ({
  value,
  onChange,
  readOnly = false,
  className = "",
  placeholder = "DD/MM/YYYY",
}) => {
  const [displayValue, setDisplayValue] = useState(formatDateToDisplay(value));

  useEffect(() => {
    setDisplayValue(formatDateToDisplay(value));
  }, [value]);

  return (
    <input
      type="text"
      inputMode="numeric"
      value={displayValue}
      readOnly={readOnly}
      placeholder={placeholder}
      onChange={(e) => {
        const nextDisplayValue = formatDateTypingValue(e.target.value);
        setDisplayValue(nextDisplayValue);

        if (!nextDisplayValue.trim()) {
          onChange && onChange("");
          return;
        }

        const parsedValue = parseDisplayDateToInput(nextDisplayValue);
        if (parsedValue) {
          onChange && onChange(parsedValue);
        }
      }}
      onBlur={() => {
        if (!displayValue.trim()) {
          setDisplayValue("");
          return;
        }

        const parsedValue = parseDisplayDateToInput(displayValue);
        if (parsedValue) {
          setDisplayValue(formatDateToDisplay(parsedValue));
        } else {
          setDisplayValue(formatDateToDisplay(value));
        }
      }}
      className={className}
    />
  );
};

const Input = ({
  label,
  value,
  onChange,
  type = "text",
  readOnly = false,
  dateDisplayFormat,
}) => (
  <div className={masterFormGridRow}>
    <label className={masterInputLabel}>{label}</label>
    {type === "date" && dateDisplayFormat === "DD/MM/YYYY" ? (
      <DateDisplayInput
        value={value}
        onChange={onChange}
        readOnly={readOnly}
        className={masterInput}
      />
    ) : (
      <input
        type={type}
        value={value}
        readOnly={readOnly}
        onChange={(e) =>
          onChange &&
          onChange(type === "text" ? e.target.value.toUpperCase() : e.target.value)
        }
        className={masterInput}
      />
    )}
  </div>
);

const Select = ({ label, value, onChange, options }) => (
  <div className={masterFormGridRow}>
    <label className={masterInputLabel}>{label}</label>
    <select
      value={value}
      onChange={(e) => onChange(e.target.value)}
      className={masterSelect}
    >
      <option value="">-- Select --</option>
      {options.map((opt, i) => (
        <option key={i} value={typeof opt === "object" ? opt.value : opt}>
          {typeof opt === "object" ? opt.label : opt}
        </option>
      ))}
    </select>
  </div>
);

const SearchableSelect = ({ label, value, onChange, options }) => {
  const [open, setOpen] = useState(false);
  const [query, setQuery] = useState("");
  const wrapperRef = useRef(null);

  const selected = options.find((opt) => opt.value === value);
  const normalizedQuery = query.trim().toLowerCase();
  const filteredOptions = options.filter((opt) => {
    const text = (opt.searchText || opt.label || "").toLowerCase();
    return text.includes(normalizedQuery);
  });

  useEffect(() => {
    if (!open) return;
    const handleClickOutside = (e) => {
      if (wrapperRef.current && !wrapperRef.current.contains(e.target)) {
        setOpen(false);
        setQuery("");
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [open]);

  return (
    <div ref={wrapperRef} className={`${masterFormGridRow} relative`}>
      <label className={masterInputLabel}>{label}</label>
      <button
        type="button"
        className={masterSelect}
        style={{ textAlign: 'left' }}
        onClick={() => setOpen((prev) => !prev)}
      >
        {selected ? selected.label : "-- Select --"}
      </button>
      {open && (
        <div className="absolute z-20 mt-1 w-full bg-white border border-slate-300 rounded shadow">
          <div className="p-2 border-b border-slate-200">
            <input
              type="text"
              placeholder="Search by name..."
              value={query}
              onChange={(e) => setQuery(e.target.value)}
              className={masterInput}
              autoFocus
            />
          </div>
          <div className="max-h-56 overflow-auto">
            {filteredOptions.length === 0 ? (
              <div className="p-2 text-xs text-slate-500">No results</div>
            ) : (
              filteredOptions.map((opt) => (
                <div
                  key={opt.value}
                  onMouseDown={() => {
                    onChange(opt.value);
                    setOpen(false);
                    setQuery("");
                  }}
                  className="px-3 py-2 text-xs cursor-pointer hover:bg-slate-100"
                >
                  {opt.label}
                </div>
              ))
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default EmployeeMaster;
